// window.customerData — replaced by window.__trackingConfig set in snippets/tracking-init.liquid
// Use getCustomer() below to read customer context safely.
// ─────────────────────────────────────────────
// GLOBAL HELPERS
// ─────────────────────────────────────────────

// ─────────────────────────────────────────────
// SHARED CART CACHE — single source of truth for /cart.js reads.
// Consolidates concurrent fetches from theme.js, custom.js, datalayer-events.js,
// and GoKwik. Returns the exact same Shopify /cart.js payload, so every existing
// GA4 / MoEngage / dataLayer event continues to fire with identical arguments.
// ─────────────────────────────────────────────
(function () {
  if (window.ReequilCart) return;
  var cached = null;
  var lastFetch = 0;
  var inFlight = null;
  var DEFAULT_TTL_MS = 1500;

  function broadcast(cart) {
    try {
      document.dispatchEvent(new CustomEvent('reequil:cart:updated', { detail: cart }));
    } catch (e) {}
  }

  function getCart(opts) {
    opts = opts || {};
    var maxAge = (typeof opts.maxAgeMs === 'number') ? opts.maxAgeMs : DEFAULT_TTL_MS;
    var force = !!opts.force;
    var now = Date.now();
    if (!force && cached && (now - lastFetch) < maxAge) {
      return Promise.resolve(cached);
    }
    if (inFlight) return inFlight;
    inFlight = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cached = cart;
        lastFetch = Date.now();
        inFlight = null;
        broadcast(cart);
        return cart;
      })
      .catch(function (err) {
        inFlight = null;
        throw err;
      });
    return inFlight;
  }

  function setCart(cart) {
    if (!cart || typeof cart !== 'object') return;
    cached = cart;
    lastFetch = Date.now();
    broadcast(cart);
  }

  function invalidate() { cached = null; lastFetch = 0; }

  function peek() { return cached; }

  window.ReequilCart = { getCart: getCart, setCart: setCart, invalidate: invalidate, peek: peek };
})();

// ─────────────────────────────────────────────
// CART COUNT AUTO-SYNC — keeps every .cart-count element synced with the
// authoritative cart state. Fixes the case where the cart is emptied via
// GoKwik (or any non-theme path) and the icon counter stays stale.
//
// Also defensively patches GoKwik's KwikCart side-cart header text, which has
// a reactivity bug where the body re-renders to "Empty" but the title stays
// at "Your Cart (N items)". GoKwik renders inside <shadow-dom-container>.
// ─────────────────────────────────────────────
(function () {
  function syncCartCountFromCart(cart) {
    if (!cart) return;
    var count = (typeof cart.item_count === 'number') ? cart.item_count : 0;
    // 1) Theme cart icon counters.
    var els = document.querySelectorAll('.cart-count, [data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = String(count);
    }
    // 2) GoKwik shadow-DOM cart header — rewrite any "Your Cart (N items?)" text.
    try {
      var sdc = document.querySelector('shadow-dom-container');
      var sr = sdc && sdc.shadowRoot;
      if (!sr) return;
      var headerNodes = sr.querySelectorAll('.side-cart-header, .side-cart-subHeader, .header-text');
      var label = 'Your Cart (' + count + (count === 1 ? ' item' : ' items') + ')';
      for (var j = 0; j < headerNodes.length; j++) {
        var node = headerNodes[j];
        // Replace only the text node so we don't blow away child elements (e.g., close button).
        for (var k = 0; k < node.childNodes.length; k++) {
          var c = node.childNodes[k];
          if (c.nodeType === 3 && /Your Cart\s*\(/.test(c.nodeValue)) {
            c.nodeValue = label;
          } else if (c.nodeType === 1 && /Your Cart\s*\(/.test(c.textContent) && c.children.length === 0) {
            c.textContent = label;
          }
        }
        // Fallback: if no matching text node was found and the element is just a text container, replace its text.
        if (node.children.length === 0 && /Your Cart\s*\(/.test(node.textContent)) {
          node.textContent = label;
        }
      }
    } catch (e) { /* GoKwik shadow DOM unavailable — ignore. */ }
  }
  document.addEventListener('reequil:cart:updated', function (e) {
    if (e && e.detail) syncCartCountFromCart(e.detail);
  });
})();

(function() {

    // STORE UTM ONLY FIRST TIME
    const params = new URLSearchParams(window.location.search);

    const utmKeys = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content'
    ];

    utmKeys.forEach(function(key) {
        const value = params.get(key);

        if (value) {
            localStorage.setItem(key, value);
        }
    });

})();

function getUTM() {
    return {
        utm_source: localStorage.getItem("utm_source") || "",
        utm_medium: localStorage.getItem("utm_medium") || "",
        utm_campaign: localStorage.getItem("utm_campaign") || "",
        utm_term: localStorage.getItem("utm_term") || "",
        utm_content: localStorage.getItem("utm_content") || ""
    };
}

function getSessionId() {
    let sid = sessionStorage.getItem("session_id");
    if (!sid) {
        sid = "SID_" + Date.now();
        sessionStorage.setItem("session_id", sid);
    }
    return sid;
}

function getCustomer() {
    var cfg = window.__trackingConfig || {};
    var cid = cfg.customerId || null;
    return {
        user_id:        cid ? String(cid) : undefined,
        customer_id:    cid || undefined,
        customer_email: cfg.customerEmail || undefined
    };
}

function isNewUser() {
    const isNew = !localStorage.getItem("visited_before");
    localStorage.setItem("visited_before", "true");
    return isNew;
}

// ─────────────────────────────────────────────
// GLOBAL MOENGAGE TRACKER (IMPORTANT)
// ─────────────────────────────────────────────
function trackMoE(eventName, payload = {}) {

    function fire() {
        if (!window.Moengage || typeof Moengage.track_event !== "function") {
            setTimeout(fire, 300); // wait until SDK ready
            return;
        }

        const finalPayload = {
            ...payload,
            ...getUTM(),
            ...getCustomer(),
            is_new_user: !localStorage.getItem("visited_before"),
            URL: window.location.href
        };

        localStorage.setItem("visited_before", "true");

        Moengage.track_event(eventName, finalPayload);
    }

    fire();
}
window.addEventListener("load", function() {

    // ALWAYS FIRE PAGE VIEW
    dataLayer.push({
        event: "page_viewed",
        page_type: window.Shopify?.analytics?.meta?.page?.pageType || "unknown",
        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),
        is_new_user: !localStorage.getItem("visited_before")
    });

    // HOMEPAGE ONLY EVENT
    var isHomepage =
        window.location.pathname === "/" ||
        window.location.pathname === "/index";

    if (isHomepage) {

        dataLayer.push({
            event: "view_homepage",
            page_type: "homepage",
            page_url: window.location.href,
            page_title: document.title,
            ...getUTM(),
            ...getCustomer(),
            is_new_user: !localStorage.getItem("visited_before")
        });

        trackMoE('view_homepage', {
            page_type: "homepage"
        });

    }
});

///////////////////////////////////// Anniversory events home page adeed
    // New events added
document.querySelectorAll("a.header__logo--image").forEach(function(logo){

    logo.addEventListener("click", function(){

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: "logo_clicked",
            destination_url: this.href,
            page_url: window.location.href,
            page_title: document.title,
            ...getUTM(),
            ...getCustomer(),
            is_new_user: !localStorage.getItem("visited_before")
        });
        // trackMoE("logo_clicked", payload);
        console.log("logo_clicked");

    });

});
function isHomePage() {
    return (
        window.location.pathname === "/" ||
        window.location.pathname === "/index"
    );
}
    // Home banner viewed
    function fireHeroBannerEvent() {
        if (!isHomePage()) return;
    const activeSlide = document.querySelector(
        ".slideshow-wrapper .swiper-slide-active"
    );

    if (!activeSlide) return;

    const link = activeSlide.querySelector("a.slideshow__item-wrap");

    const payload = {
        event: "hero_banner_viewed",

        slide_index: Number(activeSlide.dataset.swiperSlideIndex) + 1,

        slide_title: activeSlide.querySelector(".slideshow__text")?.innerText.trim() || "",

        media_type: activeSlide.querySelector("video") ? "video" : "image",

        campaign_id:getUTM().utm_campaign,

        destination_url: link?.href || "",

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    trackMoE("hero_banner_viewed", payload);

    console.log("Hero Banner Viewed", payload);
}
window.addEventListener("load", function () {

    setTimeout(fireHeroBannerEvent, 500);

});
const slider = document.querySelector(".slideshow-wrapper .swiper-wrapper");

if (slider) {

    const observer = new MutationObserver(function () {

        clearTimeout(window.heroTimer);

        window.heroTimer = setTimeout(fireHeroBannerEvent, 150);

    });

    observer.observe(slider, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"]
    });

}

// Banner Click
document.addEventListener("click", function (e) {

    const banner = e.target.closest(".slideshow__item-wrap");

    if (!banner) return;

    const slide = banner.closest(".swiper-slide");

    if (!slide) return;

    const payload = {

        event: "hero_banner_clicked",

        slide_index: Number(slide.dataset.swiperSlideIndex) + 1,

        slide_title: slide.querySelector(".slideshow__text")?.innerText.trim() || "",

        destination_url: banner.href,

        campaign_id: getUTM().utm_campaign,

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")
    };

    // GA4
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // MoEngage
    trackMoE("hero_banner_clicked", payload);

    console.log(payload);

}, true);

// Banner swipe
let previousSlideIndex = 0;

// Wait until Swiper is initialized
window.addEventListener("load", function () {
    if (!isHomePage()) return;
    const slider = document.querySelector(".slideshow-wrapper");

    if (!slider || !slider.swiper) return;

    const swiper = slider.swiper;

    previousSlideIndex = swiper.realIndex;

    swiper.on("slideChange", function () {

        const currentIndex = swiper.realIndex;

        if (currentIndex === previousSlideIndex) return;

        const payload = {
            event: "hero_banner_swiped",

            from_slide_index: previousSlideIndex + 1,
            to_slide_index: currentIndex + 1,

            swipe_direction:
                currentIndex > previousSlideIndex
                    ? "next"
                    : "previous",

            session_id: getSessionId(),

            page_url: window.location.href,
            page_title: document.title,

            ...getUTM(),
            ...getCustomer(),

            is_new_user: !localStorage.getItem("visited_before")
        };

        // GA4
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);

        // MoEngage
        //trackMoE("hero_banner_swiped", payload);

        console.log(payload);

        previousSlideIndex = currentIndex;

    });

});
//reward_banner_viewed
window.addEventListener("load", function () {

    // Homepage only
    if (
        window.Shopify?.analytics?.meta?.page?.pageType !== "home" &&
        window.location.pathname !== "/"
    ) return;

    const banner = document.querySelector(".leaderboard-banner__banner");

    if (!banner) return;

    const observer = new IntersectionObserver(function(entries){

        entries.forEach(function(entry){

            if (!entry.isIntersecting) return;

            const utm = getUTM();

            const payload = {

                event: "reward_banner_viewed",

                campaign_id: utm.utm_campaign,

                banner_text:
                    banner.querySelector("img")?.alt ||
                    "Leaderboard Banner",

                session_id: getSessionId(),

                page_url: window.location.href,
                page_title: document.title,

                ...utm,
                ...getCustomer(),

                is_new_user: !localStorage.getItem("visited_before")
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);

//            trackMoE("reward_banner_viewed", payload);

            console.log("Flash Deal Viewed", payload);
            observer.unobserve(entry.target);

        });

    }, {
        threshold: 0.5
    });

    observer.observe(banner);

});
//reward_banner_clicked
document.addEventListener("click", function(e){

    // Homepage only
    if (
        window.Shopify?.analytics?.meta?.page?.pageType !== "home" &&
        window.location.pathname !== "/"
    ) return;

    const banner = e.target.closest(".leaderboard-banner__banner");

    if (!banner) return;

    const utm = getUTM();

    const payload = {

        event: "reward_banner_clicked",

        campaign_id: utm.utm_campaign,

        banner_text:
            banner.querySelector("img")?.alt ||
            "Leaderboard Banner",

        destination_url: banner.href,

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...utm,
        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")
    };

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(payload);

    trackMoE("reward_banner_clicked", payload);

    console.log(payload);

}, true);


//flash_deal_viewed
window.addEventListener("load", function () {

    // Homepage only
    if (
        window.Shopify?.analytics?.meta?.page?.pageType !== "home" &&
        window.location.pathname !== "/"
    ) return;

    const flashDeal = document.querySelector(".deal-of-day-section");

    if (!flashDeal) return;

    const observer = new IntersectionObserver(function (entries) {

        entries.forEach(function (entry) {

            if (!entry.isIntersecting) return;

            const utm = getUTM();

            // Remaining timer
            const hrs = parseInt(flashDeal.querySelector(".hours")?.innerText || 0);
            const mins = parseInt(flashDeal.querySelector(".minutes")?.innerText || 0);
            const secs = parseInt(flashDeal.querySelector(".seconds")?.innerText || 0);

            const payload = {

                event: "flash_deal_viewed",

                deal_id:
                    flashDeal.querySelector('input[name="id"]')?.value || "",

                product_id:
                    flashDeal.querySelector('input[name="id"]')?.value || "",

                discount_percent:
                    parseInt(
                        flashDeal.querySelector(".discount")?.innerText.replace(/\D/g, "")
                    ) || 0,

                time_remaining_seconds:
                    (hrs * 3600) + (mins * 60) + secs,

                session_id: getSessionId(),

                page_url: window.location.href,
                page_title: document.title,

                ...utm,
                ...getCustomer(),

                is_new_user: !localStorage.getItem("visited_before")
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);

           // trackMoE("flash_deal_viewed", payload);

            console.log("Flash Deal Viewed", payload);

            observer.unobserve(entry.target);

        });

    }, {
        threshold: 0.5
    });

    observer.observe(flashDeal);

});
//flash_deal_product_clicked
window.addEventListener("load", function () {

    // Homepage only
    if (
        window.Shopify?.analytics?.meta?.page?.pageType !== "home" &&
        location.pathname !== "/"
    ) return;

    const flashDeal = document.querySelector(".deal-of-day-section");

    if (!flashDeal) return;

    // -------------------------
    // CLICK EVENTS
    // -------------------------

    flashDeal.addEventListener("click",function(e){

        if(e.target.closest(".deal-button")){

            pushFlashDealEvent("flash_deal_product_clicked");

            return;
        }

        if(
            e.target.closest(".deal-product-title") ||
            e.target.closest(".deal-image") ||
            e.target.closest(".deal-card")
        ){

            pushFlashDealEvent("flash_deal_product_clicked");

        }

    },true);

    // -------------------------
    // COMMON FUNCTION
    // -------------------------

    function pushFlashDealEvent(eventName){

        const hrs=parseInt(flashDeal.querySelector(".hours")?.textContent||0);
        const mins=parseInt(flashDeal.querySelector(".minutes")?.textContent||0);
        const secs=parseInt(flashDeal.querySelector(".seconds")?.textContent||0);

        const payload={

            event:eventName,

            deal_id:flashDeal.querySelector('input[name="id"]')?.value||"",

            product_id:flashDeal.querySelector('input[name="id"]')?.value||"",

            product_name:flashDeal.querySelector(".deal-product-title")?.textContent.trim()||"",

            discount_percent:
                flashDeal.querySelector(".discount")?.textContent.replace(/\D/g,"")||"",

            destination_url:
                flashDeal.querySelector("a")?.href||location.href,

            time_remaining_seconds:
                hrs*3600+mins*60+secs,

            session_id:getSessionId(),

            page_url:location.href,
            page_title:document.title,

            ...getUTM(),
            ...getCustomer(),

            is_new_user:!localStorage.getItem("visited_before")
        };

        window.dataLayer=window.dataLayer||[];
        window.dataLayer.push(payload);

        if(window.Moengage?.track_event){
            window.Moengage.track_event(eventName,payload);
        }

        console.log(eventName,payload);

    }

});
//New Arrival Banner Viewed
const sectionNew = document.querySelector(".new-launches__grid");

if (sectionNew) {

    const observer = new IntersectionObserver(function(entries){

        entries.forEach(function(entry){

            if(!entry.isIntersecting) return;

            observer.disconnect();

            const payload = {

                event: "new_arrival_product_banner_viewed",

                session_id: getSessionId(),

                page_url: window.location.href,
                page_title: document.title,

                ...getUTM(),
                ...getCustomer(),

                is_new_user: !localStorage.getItem("visited_before")
            };

            window.dataLayer.push(payload);

           // trackMoE("concern_banner_viewed", payload);

            console.log(payload);

        });

    }, {
        threshold: 0.5
    });

    observer.observe(sectionNew);

}
//New Arrival Banner Viewed
document.addEventListener("click", function(e){

    const card = e.target.closest(".new-launch-card");

    if(!card) return;

    const link = card.querySelector("a");
    const title = card.querySelector("h3");

    const payload = {

        event: "new_arrival_product_banner_clicked",

        product_id:
            card.dataset.productId ||
            link.getAttribute("href"),

        product_name: title ? title.innerText.trim() : "",

        destination_url: link.href,

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")
    };

    // GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // MoEngage
    trackMoE("new_arrival_product_banner_clicked", payload);

    console.log("Clicked", payload);

}, true);

//Shop by Concern - Banner Viewed

const section = document.querySelector(".shop-by-concern__grid");

if (section) {

    const observer = new IntersectionObserver(function(entries){

        entries.forEach(function(entry){

            if(!entry.isIntersecting) return;

            observer.disconnect();

            const payload = {

                event: "concern_banner_viewed",

                session_id: getSessionId(),

                page_url: window.location.href,
                page_title: document.title,

                ...getUTM(),
                ...getCustomer(),

                is_new_user: !localStorage.getItem("visited_before")
            };

            window.dataLayer.push(payload);

           // trackMoE("concern_banner_viewed", payload);

            console.log(payload);

        });

    }, {
        threshold: 0.5
    });

    observer.observe(section);

}

//concern_banner_clicked
document.addEventListener("click", function (e) {

    const card = e.target.closest(".concern-card");

    if (!card) return;

    const link = card.querySelector("a");

    // Banner Position (1,2,3...)
    const bannerPosition =
        Array.from(document.querySelectorAll(".concern-card")).indexOf(card) + 1;

    const payload = {

        event: "concern_banner_clicked",

        concern_name: card.dataset.concernName || "",

        banner_position: bannerPosition,

        destination_url: link ? link.href : "",

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")
    };

    // GTM / GA4
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // MoEngage
    trackMoE("concern_banner_clicked", payload);

    console.log("Concern Banner Clicked", payload);

}, true);

//category_carousel_swiped
function initCategorySwiperTracking() {

    // Current active tab
    const activeTab = document.querySelector('.vm-shop-by-category__tab.is-active');

    if (!activeTab) return;

    // Active tab content id
    const tabId = activeTab.dataset.tabTarget;

    if (!tabId) return;

    // Active tab panel
    const tabPanel = document.getElementById(tabId);

    if (!tabPanel) return;

    // Swiper inside active tab
    const slider = tabPanel.querySelector('.vm-shop-by-category__swiper');

    if (!slider || !slider.swiper) return;

    const swiper = slider.swiper;

    // Prevent duplicate binding
    if (swiper._analyticsAttached) return;

    swiper._analyticsAttached = true;

    let previousIndex = swiper.activeIndex;

    swiper.on('slideChange', function () {

        const slide = swiper.slides[swiper.activeIndex];

        const payload = {

            event: "category_carousel_swiped",

            // category_name: slide.querySelector(".brand-name-new")?.textContent.trim() || "",
            category_name: document.querySelector(".vm-shop-by-category__tab.is-active")?.innerText.trim() || "",
            from_index: previousIndex + 1,

            to_index: swiper.activeIndex + 1,

            session_id: getSessionId(),

            page_url: location.href,
            page_title: document.title,

            ...getUTM(),
            ...getCustomer(),

            is_new_user: !localStorage.getItem("visited_before")

        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);

        //trackMoE("category_carousel_swiped", payload);

        console.log(payload);

        previousIndex = swiper.activeIndex;

    });

}
window.addEventListener("load", function () {

    initCategorySwiperTracking();

    document.querySelectorAll(".vm-shop-by-category__tab").forEach(function (tab) {

        tab.addEventListener("click", function () {

            setTimeout(function () {

                initCategorySwiperTracking();

            }, 300);

        });

    });

});

//category_header_clicked
document.querySelectorAll('.vm-shop-by-category__tab').forEach(function(tab, index) {

    tab.addEventListener('click', function() {

        const payload = {

            event: 'category_header_clicked',

            category_name: tab.textContent.trim(),

            position: index + 1,

            destination_url: window.location.href,

            session_id: getSessionId(),

            page_url: window.location.href,
            page_title: document.title,

            ...getUTM(),
            ...getCustomer(),

            is_new_user: !localStorage.getItem("visited_before")

        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);

        if (window.Moengage && typeof trackMoE === "function") {
            trackMoE('category_header_clicked', payload);
        }

        console.log('category_header_clicked', payload);

    });

});
// document.addEventListener("click", function (e) {

//     const link = e.target.closest(".product-card__title a");

//     if (!link) return;

//     const slide = link.closest(".swiper-slide");

//     const categoryName =
//         slide.querySelector(".brand-name-new")?.innerText.trim() || "";

//     const position =
//         [...document.querySelectorAll(".vm-shop-by-category__swiper .swiper-slide")]
//         .indexOf(slide) + 1;

//     const payload = {

//         event: "category_header_clicked",

//         category_name: categoryName,

//         position: position,

//         destination_url: link.href,

//         session_id: getSessionId(),

//         page_url: window.location.href,
//         page_title: document.title,

//         ...getUTM(),
//         ...getCustomer(),

//         is_new_user: !localStorage.getItem("visited_before")
//     };

//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push(payload);

//     trackMoE("category_header_clicked", payload);

//     console.log(payload);

// }, true);



// Footer Link Clicked
document.addEventListener("click", function (e) {

    const link = e.target.closest(".footer a");

    if (!link) return;

    // Footer Block
    const footerBlock = link.closest(".footer-block");

    // Footer Section Heading
    const footerSection =
        footerBlock?.querySelector(".footer-block__heading")?.textContent.trim() ||
        "Unknown";
    let linkLabel = link.textContent.trim() || link.querySelector(".visually-hidden")?.textContent.trim() || link.getAttribute("aria-label") || link.title || "Social Link";
    const payload = {

        event: "footer_link_clicked",

        link_label: linkLabel,

        link_url: link.href,

        footer_section: footerSection,

        session_id: getSessionId(),

        page_url: window.location.href,

        page_title: document.title,

        ...getUTM(),

        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")

    };

    // GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // MoEngage (optional)
    if (typeof trackMoE === "function") {
        trackMoE("footer_link_clicked", payload);
    }

    console.log("footer_link_clicked", payload);

}, true);


//section_name_add_to_cart

document.addEventListener("click", function (e) {

    const btn = e.target.closest(
        '.product-card__atc, button[name="add"], .add-to-cart, .deal-button, .product-form__submit, .wht-prod-info button'
    );

    if (!btn) return;

    const card = btn.closest(
        '.product-card, .deal-card, .whatmore-event-tile-scale-in-animation, .product-item'
    );

    if (!card) return;

    // -----------------------
    // Product Details
    // -----------------------

    const productId =
        card.querySelector('input[name="product-id"]')?.value ||
        card.querySelector('input[name="id"]')?.value ||
        card.querySelector('.product-variant-id')?.value ||
        "";

    const productName =
        card.querySelector(".product-card__title")?.innerText.trim() ||
        card.querySelector(".deal-product-title")?.innerText.trim() ||
        card.querySelector(".wht-prod-info p")?.innerText.trim() ||
        card.querySelector("h3")?.innerText.trim() ||
        "";

    const destinationUrl =
        card.querySelector(".product-card__title a")?.href ||
        card.querySelector("a")?.href ||
        "";

    // -----------------------
    // Detect Section
    // -----------------------

    let sectionName = "Unknown";

    if (btn.closest(".trending-product-cards"))
        sectionName = "Trending Sale Packs";

    else if (btn.closest(".deal-of-day-section"))
        sectionName = "Deal of the Day";

    else if (btn.closest(".vm-shop-by-category"))
        sectionName = "Shop by Category";

    else if (btn.closest(".watch-shop"))
        sectionName = "Watch & Shop";

    else {

        const section =
            btn.closest("section") ||
            btn.closest("[id]");

        if (section) {

            const heading =
                section.querySelector("h2,h3,.section-title");

            if (heading)
                sectionName = heading.innerText.trim();
        }
    }

    // -----------------------
    // Payload
    // -----------------------

    const payload = {

        event: "section_name_add_to_cart",

        section_name: sectionName,

        product_id: productId,

        product_name: productName,

        destination_url: destinationUrl,

        session_id: getSessionId(),

        page_url: location.href,

        page_title: document.title,

        ...getUTM(),

        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")

    };

    // GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // MoEngage
    if (typeof trackMoE === "function") {
        trackMoE("section_name_add_to_cart", payload);
    }

    console.log("section_name_add_to_cart", payload);

}, true);










///////////////////////////// New evets End

// =========================================
// coupon_applied_success
// =========================================

document.addEventListener("click", function (e) {

    const btn = e.target.closest(
        'button[data-event-name="apply_discount"]'
    );
    console.log("click apply");

    if (!btn) return;

    // Get Coupon Code
    const couponInput = document.querySelector('input[name="reductions"]');

    const couponCode = couponInput ? couponInput.value.trim() : "";

    // Common Payload
    const payload = {
        event: "coupon_applied_success",

        coupon_code: couponCode,
        discount_amount: discountAmount,
        discount_type: discountType,
        cart_total_before: cartTotalBefore,
        cart_total_after: cartTotalAfter,

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),

        is_new_user: !localStorage.getItem("visited_before")
    };

    // --------------------
    // GA4 / GTM
    // --------------------
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    console.log("Coupon Apply Click", payload);

    // --------------------
    // MoEngage
    // --------------------
    trackMoE("coupon_applied_success", payload);

}, true);

// =========================================
// checkout_address_entered
// =========================================

const payload = {
    event: "checkout_address_entered",
    pincode: pincode,
    city: city,
    state: state,
    address_type: addressType,
};

// window.dataLayer.push(payload);
trackMoE("checkout_address_entered", payload);


// getSessionId() is defined above — duplicate removed.


// =========================================
// SESSION MANAGEMENT
// =========================================

let sessionTimeout;

// Create/Get Session
function getSessionId() {

    let sessionId = sessionStorage.getItem("session_id");

    if (!sessionId) {

        sessionId = "SID_" + Date.now() + "_" + Math.random().toString(36).substring(2, 8);

        sessionStorage.setItem("session_id", sessionId);
        sessionStorage.setItem("session_started", Date.now());

        // -------------------------
        // Common Payload
        // -------------------------
        const payload = {
            event: "session_started",
            session_id: sessionId,
            page_url: window.location.href,
            page_title: document.title,

            ...getUTM(),
            ...getCustomer()
        };

        // -------------------------
        // GTM / GA4
        // -------------------------
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);

        console.log("DataLayer:", payload);

        // -------------------------
        // MoEngage
        // -------------------------
        try {
            if (window.Moengage && typeof Moengage.track_event === "function") {

                Moengage.track_event("session_started", {
                    session_id: payload.session_id,
                    page_url: payload.page_url,
                    page_title: payload.page_title,

                    customer_id: payload.customer_id,
                    customer_email: payload.customer_email,

                    utm_source: payload.utm_source,
                    utm_medium: payload.utm_medium,
                    utm_campaign: payload.utm_campaign,
                    utm_term: payload.utm_term,
                    utm_content: payload.utm_content
                });

                // console.log("MoEngage session_started fired");
            }
        } catch (err) {
            console.error(err);
        }
    }

    return sessionId;
}

// =========================================
// Reset Session after 30 min inactivity
// =========================================

function resetSessionTimer() {

    clearTimeout(sessionTimeout);

    sessionTimeout = setTimeout(() => {

        sessionStorage.removeItem("session_id");
        sessionStorage.removeItem("session_started");

        // console.log("Session expired");

    }, 30 * 60 * 1000);

}

// =========================================
// User Activity
// =========================================

["click", "scroll", "mousemove", "keypress", "touchstart"].forEach(function (event) {

    window.addEventListener(event, function () {

        getSessionId();      // Creates new session if expired
        resetSessionTimer(); // Restart inactivity timer

    }, { passive: true });

});

// Create first session on page load
window.addEventListener("load", function () {
    getSessionId();
    resetSessionTimer();
});

resetSessionTimer();

// Detect Shopify Collection Page
if (window.location.pathname.includes('/collections/')) {

    // Collection Name
    const collectionName = document.querySelector('h1')
        ? document.querySelector('h1').innerText.trim()
        : '';

    // Collection URL
    const collectionUrl = window.location.href;

    // Product Count
    const itemCount = document.querySelectorAll(
        '.product-grid .grid__item, .card-wrapper, .product-card'
    ).length;

    // Common Payload
    const payload = {
        event: 'view_collection_page',

        collection_name: collectionName,
        collection_url: collectionUrl,
        item_count: itemCount,

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer(),

        session_id: getSessionId(),
        is_new_user: !localStorage.getItem("visited_before")
    };

    // Save first visit
    localStorage.setItem("visited_before", "true");

    // -----------------------
    // GTM / GA4
    // -----------------------
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    // console.log("GA4 Event", payload);

    // -----------------------
    // MoEngage
    // -----------------------
    try {
        if (window.Moengage && typeof Moengage.track_event === "function") {

            Moengage.track_event("view_collection_page", {

                collection_name: payload.collection_name,
                collection_url: payload.collection_url,
                item_count: payload.item_count,

                page_url: payload.page_url,
                page_title: payload.page_title,

                session_id: payload.session_id,

                customer_id: payload.customer_id,
                customer_email: payload.customer_email,

                utm_source: payload.utm_source,
                utm_medium: payload.utm_medium,
                utm_campaign: payload.utm_campaign,
                utm_term: payload.utm_term,
                utm_content: payload.utm_content,

                is_new_user: payload.is_new_user
            });

            // console.log("MoEngage Event Fired", payload);

        }
    } catch (err) {
        // console.error("MoEngage Error:", err);
    }

}

// ── SWIPER HERO BANNER CLICK EVENT ──────────────────────────────────────────

document.addEventListener('click', function(e) {

    // Detect Swiper Slide Banner
    const banner = e.target.closest(
        '.swiper-slide a, .swiper-slide .slideshow__item-wrap'
    );

    if (!banner) return;

    // Get Current Swiper Slide
    const slide = banner.closest('.swiper-slide');

    // Banner Type
    const bannerType = 'hero';

    // Destination URL
    const destinationUrl = banner.href || 'NA';

    // Banner Title
    let bannerTitle =
        banner.dataset.bannerTitle ||
        banner.getAttribute('title') ||
        banner.getAttribute('aria-label') ||
        banner.querySelector('img')?.alt ||
        destinationUrl.split('/').pop() ||
        'NA';

    // Slide Position
    let bannerPosition = 1;

    if (slide) {

        // Ignore duplicated swiper slides
        const realIndex =
            slide.getAttribute('data-swiper-slide-index');

        bannerPosition =
            realIndex !== null ?
            parseInt(realIndex) + 1 :
            Array.from(
                document.querySelectorAll('.swiper-slide')
            ).indexOf(slide) + 1;
    }
    // PUSH EVENT
    window.dataLayer.push({
        event: 'banner_clicked',

        banner_type: bannerType,
        banner_title: bannerTitle,
        banner_destination_url: destinationUrl,
        banner_position: bannerPosition,

        page_url: window.location.href,
        page_title: document.title,
        ...getUTM(),
        ...getCustomer(),
        is_new_user: !localStorage.getItem("visited_before")
    });
    try {
        if (window.Moengage && typeof Moengage.track_event === 'function') {
            Moengage.track_event("banner_clicked", {
                banner_type: bannerType,
                banner_title: bannerTitle,
                banner_destination_url: destinationUrl,
                banner_position: bannerPosition,

                page_url: window.location.href,
                page_title: document.title,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            });
         }

        } catch (err) {
            console.error("MoEngage Error:", err);
        }
}, true);

// ── ANNOUNCEMENT BAR CLICKED EVENT ──────────────────────────────────────────

document.addEventListener('click', function(e) {

    // Detect Announcement Bar Link
    const announcement = e.target.closest(
        'announcement-bar__item, announcement-bar__item--link, announcement-bar__content'
    );

    if (!announcement) return;

    // Announcement Text
    const announcementText =
        announcement.innerText.trim() ||
        announcement.closest('.announcement-bar')?.innerText.trim() ||
        announcement.getAttribute('aria-label') ||
        'NA';

    // Destination URL
    const destinationUrl = announcement.href || 'NA';

    // PUSH EVENT
    window.dataLayer.push({
        event: 'announcement_bar_clicked',

        announcement_text: announcementText,
        destination_url: destinationUrl,

        page_url: window.location.href,
        page_title: document.title,
        ...getUTM(),
        ...getCustomer(),
        is_new_user: !localStorage.getItem("visited_before")
    });
}, true);

// WHATSAPP SUPPORT CHAT EVENT

document.addEventListener(
  'click',
  function (e) {

    // Detect WhatsApp Support Button
    const btn = e.target.closest(
      'a[href*="wa.me"], \
       a[href*="api.whatsapp.com"]'
    );

    if (!btn) return;

    // CHANNEL
    const supportChannel = 'whatsapp';

    // BUTTON TEXT
    const buttonText =
      btn.innerText.trim() || 'CHAT WITH US';

    // USER ID
    let userId =
      window.customer?.id ||
      Shopify?.customer?.id ||
      getCustomer?.()?.customer_id ||
      'guest';

    // PAYLOAD
    var payload = {
      event: 'support_chat_initiated',

      support_channel: supportChannel,
      button_text: buttonText,

      referrer_page: document.referrer || 'direct',

      destination_url: btn.href,

      user_id: userId,

      session_id: getSessionId(),

      page_url: window.location.href,
      page_title: document.title,

      ...getUTM(),
    ...getCustomer(),
    is_new_user: !localStorage.getItem("visited_before")
    };

    // DATALAYER
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

  },
  true
);
// ─────────────────────────────────────────────
// support_ticket_submitted
// Reequil Raise Ticket Form Tracking
// URL: /pages/raise-ticket
// ─────────────────────────────────────────────

(function () {

  const form = document.querySelector('#contact-form');

  if (!form) return;

  // Prevent duplicate firing only during same submit cycle
  let isSubmitting = false;

  form.addEventListener('submit', function () {

    if (isSubmitting) return;

    isSubmitting = true;

    // Wait for alert / API success
    setTimeout(function () {

      // SUCCESS CHECK
      // Since success comes via JS alert
      const success =
        document.body.innerText.includes('successfully') ||
        document.body.innerText.includes('Thank you');

      // If your site uses native alert()
      // then just fire event after timeout
      if (!success) {
        // still continue because alert may not exist in DOM
      }

      // SUBJECT
      let issueType =
        document.querySelector('#subject')?.value ||
        'general_support';

      // MESSAGE
      let message =
        document.querySelector('#message')?.value || '';

      // ORDER ID EXTRACTION
      let orderId = '';

      const orderMatch =
        message.match(/(RQ|ORD|#)?\d{4,}/i);

      if (orderMatch) {
        orderId = orderMatch[0];
      }

      // USER ID
      let userId =
        window.customer?.id ||
        window.Shopify?.customer?.id ||
        (typeof getCustomer === 'function'
          ? getCustomer()?.customer_id
          : '') ||
        'guest';

      // UNIQUE TICKET EVENT ID
      const ticketEventId =
        'ticket_' + Date.now();

      // PAYLOAD
      var payload = {
        event: 'support_ticket_submitted',

        ticket_event_id: ticketEventId,

        issue_type: issueType,
        order_id: orderId,
        user_id: userId,

        support_page: window.location.pathname,

        session_id:
          typeof getSessionId === 'function'
            ? getSessionId()
            : '',

        page_url: window.location.href,
        page_title: document.title,

        ...(
          typeof getUTM === 'function'
            ? getUTM()
            : {}
        ),

        ...(
          typeof getCustomer === 'function'
            ? getCustomer()
            : {}
        ),

        is_new_user:
          !localStorage.getItem("visited_before")
      };

      // DATALAYER
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push(payload);

      console.log(
        'support_ticket_submitted fired',
        payload
      );

      // MOENGAGE
      try {

        if (
          window.Moengage &&
          typeof Moengage.track_event === 'function'
        ) {

          Moengage.track_event(
            'support_ticket_submitted',
            {
              ticket_event_id: ticketEventId,

              issue_type: payload.issue_type,
              order_id: payload.order_id,
              user_id: payload.user_id,
              support_page: payload.support_page,

              ...(
                typeof getUTM === 'function'
                  ? getUTM()
                  : {}
              ),

              ...(
                typeof getCustomer === 'function'
                  ? getCustomer()
                  : {}
              ),

              is_new_user:
                !localStorage.getItem("visited_before")
            }
          );

        }

      } catch (err) {
        console.log(err);
      }

      // RESET
      // Allows same email to submit again
      setTimeout(function () {
        isSubmitting = false;
      }, 2000);

    }, 2500);

  });

})();
// ── DOM-READY EVENTS ─────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
        // Tracks product video tile open event on click for GA4
        function handleProductVideoTileOpen(e) {
            var card = e.target.closest('.swiperDivContainer .containers.lively_sf_container_hover');
            if (card) {
                var productTitle = card.querySelector('.productName')?.innerText.trim() || '';
                var productName = card.querySelector('.productName')?.innerText.trim() || '';
                window?.GA4Events?.productVideoTileOpen({
                    click_text: productName,
                    product_title: productTitle
                });
            }
        }
        // Variables for tracking touch and mouse swipe start and end positions
        let touchStartX = 0,
            touchEndX = 0,
            mouseDownX = 0,
            mouseUpX = 0,
            mouseActiveCard = null;
        // Handle touchstart event for initiating swipe detection on mobile
        function handleTouchStart(e) {
            const card = e.target.closest('.embla__slide .videoCardActive');
            if (card) {
                touchStartX = e.changedTouches[0].screenX;
                card.setAttribute('data-swipe-active', 'true');
            }
        }
        // Handle touchend event to detect swipe direction and fire GA4 swipe event on mobile
        function handleTouchEnd(e) {
            const card = e.target.closest('.embla__slide .videoCardActive');
            if (card && card.getAttribute('data-swipe-active') === 'true') {
                touchEndX = e.changedTouches[0].screenX;
                card.removeAttribute('data-swipe-active');
                let diff = touchEndX - touchStartX;
                if (Math.abs(diff) > 30) {
                    let swipe_direction = diff > 0 ? 'right' : 'left';
                    let productTitle = card.querySelector('.productName')?.innerText.trim() || '';
                    window?.GA4Events?.productVideoTileSwipe?.({
                        click_text: productTitle,
                        product_title: productTitle,
                        swipe_direction: swipe_direction,
                    });
                }
            }
        }
        // Handle mousedown event for desktop swipe detection start
        function handleMouseDown(e) {
            const card = e.target.closest('.embla__slide .videoCardActive');
            if (card) {
                mouseDownX = e.screenX;
                mouseActiveCard = card;
                card.setAttribute('data-mouse-swipe-active', 'true');
            }
        }
        // Handle mouseup event to detect swipe direction and fire GA4 swipe event on desktop
        function handleMouseUp(e) {
            if (!mouseActiveCard) return;
            const card = e.target.closest('.embla__slide .videoCardActive');
            if (card === mouseActiveCard && card.getAttribute('data-mouse-swipe-active') === 'true') {
                mouseUpX = e.screenX;
                card.removeAttribute('data-mouse-swipe-active');
                let diff = mouseUpX - mouseDownX;
                if (Math.abs(diff) > 30) {
                    let swipe_direction = diff > 0 ? 'right' : 'left';
                    let productTitle = card.querySelector('.productName')?.innerText.trim() || '';
                    window?.GA4Events?.productVideoTileSwipe?.({
                        click_text: productTitle,
                        product_title: productTitle,
                        swipe_direction: swipe_direction,
                    });
                }
            }
            mouseActiveCard = null;
        }
        // Handle minimize button click event to track minimize action on video tile
        function handleMinimizeClick(e) {
            const pipBtn = e.target.closest('.lv_pipContainer');
            if (pipBtn) {
                const card = pipBtn.closest('.videoCardActive') || pipBtn.closest('.embla__slide');
                let productTitle = '';
                if (card) {
                    const nameEl = card.querySelector('.productName');
                    productTitle = nameEl ? nameEl.innerText.trim() : '';
                }
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('product_video_tile_minimize', {
                        click_text: productTitle,
                        product_title: productTitle,
                    });
                }
                if (window?.GA4Events?.productVideoTileMinimize) {
                    window.GA4Events.productVideoTileMinimize({
                        click_text: productTitle,
                        product_title: productTitle
                    });
                }
            }
        }
        // Setup GA4 events for product lists: viewItemList fired on scroll and selectItem on click
        function setupProductListsGAEvents() {
            const productLists = document.querySelectorAll('.featured-collection__items, .products-list');
            if (
                !productLists.length ||
                typeof GA4Events === 'undefined' ||
                typeof GA4Events.viewItemList !== 'function' ||
                typeof GA4Events.selectItem !== 'function'
            )
                return;
            // Extract product data from a product card for GA4 events
            function getProductData(productCard, productList) {
                const productLink = productCard.querySelector('a.reversed-link');
                const priceEl = productCard.querySelector('.f-price-item--regular.sale_prices_new');
                const originalPriceEl = productCard.querySelector('.f-price-item--regular.sale_prices s');
                const productName = productLink?.textContent.trim() || 'NA';
                const productId = productCard.querySelector("input[name='product-id']")?.value || 'NA';
                const variantId = productCard.querySelector("input[name='id']")?.value || 'NA';
                const price = parseInt((priceEl?.textContent || '0').replace(/[^\d]/g, '')) || 0;
                const originalPrice = parseInt((originalPriceEl?.textContent || '0').replace(/[^\d]/g, '')) || price;
                const discount = originalPrice - price;
                const index = [...productList.querySelectorAll('.product-card')].indexOf(productCard) + 1;
                const item_brand = productCard.getAttribute('data-brand') || 'Reequil';
                const item_category = productCard.getAttribute('data-category') || 'NA';
                const item_category2 = productCard.getAttribute('data-category2') || 'NA';
                return {
                    item_id: productId,
                    item_name: productName,
                    coupon: 'NA',
                    discount: isNaN(discount) ? 0 : discount,
                    index: isNaN(index) ? 0 : index,
                    item_brand,
                    item_category,
                    item_category2,
                    item_variant: variantId,
                    price: isNaN(price) ? 0 : price,
                    quantity: 1,
                };
            }
            // Get dynamic list info (id and name) for the product list to use in GA4 events
            function getListInfo(productList) {
                const section = productList.closest('.section');
                if (section) {
                    let item_list_id = section.getAttribute('data-id') || section.className || 'home_featured';
                    let heading = section.querySelector('.section__heading, .collection__title, h2, h3');
                    let item_list_name = heading ? heading.textContent.trim() : 'Featured Collection';
                    return {
                        item_list_id,
                        item_list_name
                    };
                }
                if (document.querySelector('.collection.page-width')) {
                    const section = productList.closest('.section');
                    let item_list_id = 'collection_home';
                    let item_list_name = 'Featured Collection';
                    if (section && section.hasAttribute('data-id')) {
                        item_list_id = section.getAttribute('data-id');
                        let heading =
                            section.querySelector('.bundle-heading') ||
                            section.querySelector('.section__heading, .collection__title');
                        if (heading) item_list_name = heading.textContent.trim();
                    }
                    return {
                        item_list_id,
                        item_list_name
                    };
                }
                if (document.querySelector('.bundle-heading')) {
                    const bundleSlider = productList.closest('bundle-slider');
                    let item_list_id = 'pdp_bundle';
                    if (bundleSlider && bundleSlider.hasAttribute('data-section-id')) {
                        const sectionId = bundleSlider.getAttribute('data-section-id');
                        const match = sectionId.match(/template--(\d+)__/);
                        item_list_id = match ? match[1] : sectionId;
                    }
                    const bundleHeading = document.querySelector('.bundle-heading');
                    let item_list_name = bundleHeading ?
                        bundleHeading.textContent.trim() :
                        document.querySelector('h1.product__title')?.textContent.trim() || 'PDP Bundle';
                    return {
                        item_list_id,
                        item_list_name
                    };
                }
                return {
                    item_list_id: 'NA',
                    item_list_name: 'NA'
                };
            }

            // Observer to fire 'viewItemList' GA4 event when product list becomes visible in viewport
            productLists.forEach((productList) => {
                let hasFiredView = false;
                const {
                    item_list_id,
                    item_list_name
                } = getListInfo(productList);
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting && !hasFiredView) {
                                hasFiredView = true;
                                const items = [];
                                productList.querySelectorAll('.product-card').forEach((card) => {
                                    items.push(getProductData(card, productList));
                                });
                                GA4Events.viewItemList({
                                    item_list_id,
                                    item_list_name,
                                    currency: 'INR',
                                    value: items.reduce((sum, item) => sum + (item.price || 0), 0),
                                    items,
                                    ...getUTM(),
                                    ...getCustomer(),
                                    is_new_user: !localStorage.getItem("visited_before")
                                });
                            }
                        });
                    }, {
                        threshold: 0.2
                    }
                );
                observer.observe(productList);
                // Listen for product card click to fire 'selectItem' GA4 event
                productList.addEventListener('click', function(e) {
                    if (e.target.closest('.product-card')?.hasAttribute('data-ga-clicked')) return;
                    const productCard = e.target.closest('.product-card');
                    if (!productCard || !productList.contains(productCard)) return;
                    productCard.setAttribute('data-ga-clicked', 'true');
                    setTimeout(() => {
                        productCard.removeAttribute('data-ga-clicked');
                    }, 500);
                    const itemData = getProductData(productCard, productList);
                    const {
                        item_list_id,
                        item_list_name
                    } = getListInfo(productList);
                    GA4Events.selectItem({
                        item_list_id,
                        item_list_name,
                        items: [itemData]
                    });
                });
            });
        }
        // Fetch current cart data and update cart count element
        // Routed through ReequilCart.getCart() so concurrent callers share one HTTP request.
        function updateCartCount() {
            var p = (window.ReequilCart && window.ReequilCart.getCart)
                ? window.ReequilCart.getCart({ force: true })
                : fetch('/cart.js').then((r) => r.json());
            p.then((cart) => {
                const el = document.querySelector('.cart-count');
                if (el) el.textContent = cart.item_count || 0;
            }).catch(console.error);
        }
        // Add specified product variant and quantity to cart via fetch API
        function addToCart(variantId, quantity) {
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity
                }),
            }).then((r) => r.json());
        }
        // Show quantity selector UI and hide Add To Cart button after adding to cart
        function showQtyAndHideATC(form, qty = 1) {
            const atcBtn = form.querySelector('.product-card__atc');
            const qtyEl = form.querySelector('quantity-element');
            const qtyELwrapper = form.querySelector('.quanity_selector');
            if (atcBtn) atcBtn.style.display = 'none';
            if (qtyEl) {
                qtyEl.style.display = 'flex';
                if (qtyELwrapper) qtyELwrapper.style.display = 'block';
                const input = qtyEl.querySelector('.qty-value');
                if (input) input.value = qty;
            }
        }
        // Extract variant ID from quantity element or hidden input in form
        function getVariantId(form) {
            const fromQty = form.querySelector('quantity-element')?.dataset?.varid;
            if (fromQty) return fromQty;
            const hidden = form.querySelector('input[name="id"]');
            return hidden ? hidden.value : null;
        }
        // Stop propagation and prevent default on event
        function stopAll(e) {
            e.preventDefault();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            e.stopPropagation();
        }
        // Handle Add To Cart click event: stop default, add item to cart, update UI, cart count, and fire GA4
        function handleATCClick(e, btn) {
            stopAll(e);
            const form = btn.closest('form');
            if (!form) return;
            const variantId = getVariantId(form);
            if (!variantId) {
                console.warn('Variant ID not found');
                return;
            }
            // Optimistic UI: show qty selector immediately so the button reacts in <100ms.
            // Previously gated behind setTimeout(..., 2000) which made the click feel slow.
            showQtyAndHideATC(form, 1);
            addToCart(variantId, 1)
                .then((addedItem) => {
                    // /cart/add.js mutates the cart on the server. Drop the cached read so the
                    // next consumer of ReequilCart.getCart() pulls fresh totals/items.
                    if (window.ReequilCart) window.ReequilCart.invalidate();
                    updateCartCount();
                    // Fire GA4 add_to_cart once, using the response from /cart/add.js
                    if (window.GA4Events && typeof window.GA4Events.addToCart === 'function') {
                        const price = (addedItem.price || 0) / 100;
                        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
                        window.GA4Events.addToCart({
                            currency: currency,
                            value: price,
                            items: [{
                                item_id: String(addedItem.variant_id || variantId),
                                item_name: addedItem.product_title || addedItem.title || 'NA',
                                coupon: 'NA',
                                discount: 0,
                                item_brand: addedItem.vendor || 'NA',
                                item_category: addedItem.product_type || 'NA',
                                item_category2: (addedItem.tags && addedItem.tags[0]) ? addedItem.tags[0] : 'NA',
                                item_variant: addedItem.variant_title || 'NA',
                                price: price,
                                quantity: 1
                            }],
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                    // Fire MoEngage Add To Cart directly (replaces the disabled Shopify connector event)
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            const _price = (addedItem.price || 0) / 100;
                            const _currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
                            Moengage.track_event('Add To Cart', {
                                'Product ID': String(addedItem.variant_id || variantId),
                                'Product Title': addedItem.product_title || addedItem.title || 'NA',
                                'Product Price': _price,
                                'Variation ID': String(addedItem.variant_id || variantId),
                                'Variation Title': addedItem.variant_title || 'NA',
                                'Vendor Name': addedItem.vendor || 'NA',
                                'Currency': _currency,
                                'Quantity': 1,
                                'Product Type': addedItem.product_type || 'NA',
                                'Product URL': addedItem.url ? (window.location.origin + addedItem.url) : 'NA',
                                'Image URL': addedItem.image || 'NA',
                                'URL': window.location.href
                            });
                        }
                    } catch (moErr) {
                        /* Non-blocking */
                    }
                })
                .catch((err) => console.error('Custom ATC failed:', err));
        }
        // Attach event listeners for video tile open, swipe detection, minimize, and Add To Cart
        // NOTE: A single document-level capture handler covers all .product-card__atc buttons.
        // Per-button initBindings has been removed to prevent duplicate ATC handling.
        document.body.addEventListener('click', handleProductVideoTileOpen);
        document.body.addEventListener('touchstart', handleTouchStart);
        document.body.addEventListener('touchend', handleTouchEnd);
        document.body.addEventListener('mousedown', handleMouseDown);
        document.body.addEventListener('mouseup', handleMouseUp);
        document.body.addEventListener('click', handleMinimizeClick);
        document.addEventListener(
            'click',
            function(e) {
                const btn = e.target.closest && e.target.closest('.product-card__atc');
                if (!btn) return;
                const form = btn.closest('.form_container form');
                if (!form) return;
                handleATCClick(e, btn);
            },
            true
        );

        // ── GA4 Event Deduplication Guard ────────────────────────────────────────
        // Wraps addToCart, removeFromCart, and purchase to prevent the same event
        // from firing more than once within a 2-second window. This guards against
        // any residual double-invocations from multiple event sources (Shopify native
        // connector, MoEngage SDK, and custom theme handlers all firing on the same
        // user action).
        (function() {
            if (!window.GA4Events) return;
            var _fired = {};
            var DEDUP_MS = 2000;

            function shouldFire(key) {
                var now = Date.now();
                if (_fired[key] && (now - _fired[key]) < DEDUP_MS) return false;
                _fired[key] = now;
                return true;
            }
            // Deduplicate add_to_cart
            var _origATC = window.GA4Events.addToCart;
            window.GA4Events.addToCart = function(data) {
                var variantId = (data.items && data.items[0]) ? (data.items[0].item_id || 'unknown') : 'unknown';
                if (!shouldFire('atc_' + variantId)) return;
                _origATC.call(window.GA4Events, data);
            };
            // Deduplicate remove_from_cart
            var _origRFC = window.GA4Events.removeFromCart;
            window.GA4Events.removeFromCart = function(data) {
                var variantId = (data.items && data.items[0]) ? (data.items[0].item_id || 'unknown') : 'unknown';
                if (!shouldFire('rfc_' + variantId)) return;
                _origRFC.call(window.GA4Events, data);
            };
            // Deduplicate purchase (guard against Shopify native + GoKwik + custom all firing)
            var _origPurchase = window.GA4Events.purchase;
            window.GA4Events.purchase = function(data) {
                var txnId = data.transaction_id || 'unknown';
                if (!shouldFire('purchase_' + txnId)) return;
                _origPurchase.call(window.GA4Events, data);
            };
        })();

        // ── GoKwik Cart Event Interceptors ───────────────────────────────────────────
        // GoKwik KwikCart manages its own cart UI (shadow DOM) and calls Shopify's
        // cart API via XHR — bypassing theme web components entirely.
        // This block handles: Removed from Cart, item_remove_from_cart,
        // Update Cart, and view_cart for all GoKwik-driven cart interactions.
        (function() {
            var _cartCache = {}; // keyed by item.key AND 'v'+variant_id

            function _cacheCart(cartData) {
                try {
                    (cartData.items || []).forEach(function(item) {
                        _cartCache[item.key] = item;
                        _cartCache['v' + item.variant_id] = item;
                    });
                } catch (e) {}
            }

            // Shared item payload builder for MoEngage events
            function _itemPayload(item, qty, currency) {
                return {
                    'Product ID': String(item.variant_id),
                    'Product Title': item.product_title || item.title || 'NA',
                    'Product Price': (item.price || 0) / 100,
                    'Product Type': item.product_type || 'NA',
                    'Product URL': item.url ? (window.location.origin + item.url) : 'NA',
                    'Image URL': item.image || 'NA',
                    'Variation ID': String(item.variant_id),
                    'Variation Title': item.variant_title || 'NA',
                    'Vendor Name': item.vendor || 'NA',
                    'Currency': currency,
                    'Quantity': qty,
                    'URL': window.location.href
                };
            }

            // ── /cart/change.js handler: fires Remove or Update events ──────────────
            function _fireCartChangeEvents(itemId, newQty) {
                try {
                    var item = _cartCache[itemId] || _cartCache['v' + String(itemId).split(':')[0]];
                    if (!item) return;
                    var price = (item.price || 0) / 100;
                    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';

                    if (newQty === 0) {
                        // ── Item removed completely ─────────────────────────────────────
                        var removedQty = item.quantity;
                        var removePayload = _itemPayload(item, removedQty, currency);

                        try {
                            if (window.Moengage && typeof Moengage.track_event === 'function') {
                                Moengage.track_event('Removed from Cart', removePayload);
                                Moengage.track_event('item_remove_from_cart', removePayload);
                            }
                        } catch (e) {}

                        try {
                            if (window.GA4Events && typeof GA4Events.removeFromCart === 'function') {
                                GA4Events.removeFromCart({
                                    items: [{
                                        item_id: String(item.variant_id),
                                        item_name: item.product_title || item.title || 'NA',
                                        item_brand: item.vendor || 'NA',
                                        item_category: item.product_type || 'NA',
                                        price: price,
                                        quantity: removedQty
                                    }],
                                    currency: currency,
                                    value: price * removedQty,
                                    ...getUTM(),
                                    ...getCustomer(),
                                    is_new_user: !localStorage.getItem("visited_before")
                                });
                            }
                        } catch (e) {}

                    } else {
                        // ── Quantity changed (not removed) → Update Cart ────────────────
                        var updatePayload = _itemPayload(item, newQty, currency);

                        try {
                            if (window.Moengage && typeof Moengage.track_event === 'function') {
                                Moengage.track_event('Update Cart', updatePayload);
                            }
                        } catch (e) {}

                        // GA4: fire viewCart to reflect the updated cart state
                        try {
                            if (window.GA4Events && typeof GA4Events.viewCart === 'function') {
                                var _cartPromise = (window.ReequilCart && window.ReequilCart.getCart)
                                    ? window.ReequilCart.getCart({ force: true })
                                    : fetch('/cart.js').then(function(r) { return r.json(); });
                                _cartPromise.then(function(cart) {
                                    var items = (cart.items || []).map(function(ci) {
                                        return {
                                            item_id: String(ci.variant_id),
                                            item_name: ci.product_title || ci.title || 'NA',
                                            item_brand: ci.vendor || 'NA',
                                            item_category: ci.product_type || 'NA',
                                            price: (ci.price || 0) / 100,
                                            quantity: ci.quantity
                                        };
                                    });
                                    GA4Events.viewCart({
                                        currency: currency,
                                        value: (cart.total_price || 0) / 100,
                                        items: items
                                    });
                                }).catch(function() {});
                            }
                        } catch (e) {}
                    }
                } catch (e) {}
            }

            // ── view_cart: fires when the GoKwik cart panel is opened ───────────────
            var _lastViewCart = 0;

            function _fireViewCart() {
                var now = Date.now();
                if (now - _lastViewCart < 1500) return; // 1.5 s dedup
                _lastViewCart = now;
                var _cartPromise = (window.ReequilCart && window.ReequilCart.getCart)
                    ? window.ReequilCart.getCart()
                    : fetch('/cart.js').then(function(r) { return r.json(); });
                _cartPromise.then(function(cart) {
                    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
                    var value = (cart.total_price || 0) / 100;
                    var items = (cart.items || []).map(function(ci) {
                        return {
                            item_id: String(ci.variant_id),
                            item_name: ci.product_title || ci.title || 'NA',
                            item_brand: ci.vendor || 'NA',
                            item_category: ci.product_type || 'NA',
                            price: (ci.price || 0) / 100,
                            quantity: ci.quantity
                        };
                    });
                    // DATA LAYER PUSH
                    window.dataLayer.push({
                        event: 'cart_viewed',

                        currency: currency,
                        cart_total: value,
                        item_count: cart.item_count || 0,
                        product_ids: items.map(i => i.item_id),
                        has_coupon: cart.cart_level_discount_applications &&
                            cart.cart_level_discount_applications.length > 0,

                        items: items,

                        page_url: window.location.href,
                        page_title: document.title,

                        ...getUTM(),
                        ...getCustomer(),

                        is_new_user: !localStorage.getItem("visited_before")
                    });

                    // GA4
                    try {
                        if (window.GA4Events && typeof GA4Events.viewCart === 'function') {
                            GA4Events.viewCart({
                                currency: currency,
                                value: value,
                                items: items,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}

                    // MoEngage
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('view_cart', {
                                'Currency': currency,
                                'Cart Total': value,
                                'Item Count': cart.item_count || 0,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                            Moengage.track_event("cart_viewed", {
                                currency: currency,
                                cart_total: value,
                                item_count: cart.item_count || 0,
                                product_ids: items.map(i => i.item_id),
                                has_coupon: cart.cart_level_discount_applications &&
                                    cart.cart_level_discount_applications.length > 0,
                                items: items,
                                page_url: window.location.href,
                                page_title: document.title,

                                ...getUTM(),
                                ...getCustomer(),

                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }).catch(function() {});
            }

            // Listen for clicks on the cart icon button (opens GoKwik cart)
            document.addEventListener('click', function(e) {
                if (e.target.closest('.cart-drawer-button')) {
                    setTimeout(_fireViewCart, 400); // wait for GoKwik cart to render
                }
            }, true);

            // ── XHR interceptor — GoKwik uses XHR for /cart/change.js ───────────────
            var _origOpen = XMLHttpRequest.prototype.open;
            var _origSend = XMLHttpRequest.prototype.send;

            XMLHttpRequest.prototype.open = function(method, url) {
                this.__rrMethod = method;
                this.__rrUrl = url;
                return _origOpen.apply(this, arguments);
            };

            XMLHttpRequest.prototype.send = function(body) {
                var xhr = this,
                    url = xhr.__rrUrl || '',
                    rb = body;
                xhr.addEventListener('load', function() {
                    try {
                        var resp = JSON.parse(xhr.responseText);
                        if (url.indexOf('/cart.js') !== -1 && (!xhr.__rrMethod || xhr.__rrMethod.toUpperCase() === 'GET')) {
                            _cacheCart(resp);
                            // Feed shared cache so other consumers don't refetch.
                            if (window.ReequilCart && window.ReequilCart.setCart) window.ReequilCart.setCart(resp);
                        } else if (url.indexOf('/cart/change') !== -1) {
                            var req = {};
                            try {
                                req = JSON.parse(rb);
                            } catch (e) {}
                            if (typeof req.quantity === 'number') {
                                _fireCartChangeEvents(req.id || '', req.quantity);
                            }
                            _cacheCart(resp); // update cache with post-change state
                            // GoKwik's cart-change response IS the updated cart — share it.
                            if (window.ReequilCart && window.ReequilCart.setCart) window.ReequilCart.setCart(resp);
                        }
                    } catch (e) {}
                });
                return _origSend.apply(this, arguments);
            };

            // Warm the cache immediately on page load
            try {
                var _initXhr = new XMLHttpRequest();
                _origOpen.call(_initXhr, 'GET', '/cart.js', true);
                _initXhr.addEventListener('load', function() {
                    try {
                        var _initCart = JSON.parse(_initXhr.responseText);
                        _cacheCart(_initCart);
                        if (window.ReequilCart && window.ReequilCart.setCart) window.ReequilCart.setCart(_initCart);
                    } catch (e) {}
                });
                _origSend.call(_initXhr);
            } catch (e) {}
        })();

        // ── begin_checkout: fires GA4 + MoEngage when GoKwik checkout CTA is clicked ─
        // Listens for clicks on the GoKwik checkout button, fetches the current cart,
        // and fires GA4 begin_checkout + MoEngage begin_checkout. 2-second dedup guard
        // prevents double-fires if the button is tapped twice quickly.
        (function() {
            var _lastBeginCheckout = 0;
            document.addEventListener('click', function(e) {
                var btn = e.target.closest('.gokwik-checkout button, #gokwik-checkout, [data-kwik-checkout], button[id*="gokwik"], button[name="checkout"], a[href*="/checkout"]');
                if (!btn) return;
                var now = Date.now();
                if (now - _lastBeginCheckout < 2000) return; // 2 s dedup
                _lastBeginCheckout = now;
                var _cartPromise = (window.ReequilCart && window.ReequilCart.getCart)
                    ? window.ReequilCart.getCart()
                    : fetch('/cart.js').then(function(r) { return r.json(); });
                _cartPromise.then(function(cart) {
                    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
                    var value = (cart.total_price || 0) / 100;
                    var items = (cart.items || []).map(function(ci) {
                        return {
                            item_id: String(ci.variant_id),
                            item_name: ci.product_title || ci.title || 'NA',
                            item_brand: ci.vendor || 'NA',
                            item_category: ci.product_type || 'NA',
                            item_variant: ci.variant_title || 'NA',
                            price: (ci.price || 0) / 100,
                            quantity: ci.quantity
                        };
                    });
                    // GA4
                    try {
                        if (window.GA4Events && typeof GA4Events.beginCheckout === 'function') {
                            GA4Events.beginCheckout({
                                coupon: '',
                                currency: currency,
                                value: value,
                                items: items,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                    // MoEngage
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('begin_checkout', {
                                'Cart Total': value,
                                'Item Count': cart.item_count || 0,
                                'Currency': currency,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }).catch(function() {});
            }, true);
        })();

        // ── GoKwik postMessage event handler ─────────────────────────────────────────
        // GoKwik's checkout runs in an iframe and communicates with the parent window
        // via window.postMessage. This block listens for GoKwik events and maps them
        // to the correct GA4 + MoEngage tracking calls.
        //
        // Events handled:
        //   order_placed / payment_success / checkout_complete → GA4 purchase + MoEngage order events
        //   payment_method_selected                            → MoEngage Payment_Method_Selected_GK + GA4 checkout_payment_initiated
        //   payment_complete                                   → MoEngage Payment_Complete_GK
        //   checkout_exit / checkout_abandoned                 → MoEngage checkout_abandoned
        //
        // No duplicate fires: order events are deduped by order_id (window.__rrGkOrderFired).
        window.addEventListener('message', function(evt) {
            try {
                var d = evt.data;
                if (!d || typeof d !== 'object') return;
                var evtType = String(d.event || d.type || d.action || '').toLowerCase();
                var payload = d.data || d.payload || d;

                // ── Order placed / payment success → purchase ─────────────────────────
                if (/order_placed|payment_success|checkout_complete|order_confirmed/.test(evtType)) {
                    var orderId = String(payload.order_id || payload.orderId || payload.merchantOrderId || '');
                    if (!orderId) return; // no real order ID — skip

                    // Dedup: fire once per order_id per page session
                    if (window.__rrGkOrderFired === orderId) return;
                    window.__rrGkOrderFired = orderId;

                    // GoKwik may send amount in paise (×100) or in rupees — detect by magnitude
                    var rawAmt = parseFloat(payload.total_price || payload.totalPrice || payload.amount || payload.order_total || 0);
                    var revenue = rawAmt > 10000 ? rawAmt / 100 : rawAmt;
                    var currency = payload.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
                    var paymentMethod = payload.payment_method || payload.paymentMethod || payload.mode || 'NA';
                    var coupon = payload.coupon_code || payload.couponCode || '';

                    var lineItems = (payload.line_items || payload.lineItems || payload.items || []).map(function(item) {
                        var p = (item.price || 0);
                        return {
                            item_id: String(item.variant_id || item.variantId || item.sku || 'NA'),
                            item_name: item.title || item.name || item.product_title || 'NA',
                            item_brand: item.vendor || 'NA',
                            item_category: item.product_type || 'NA',
                            item_variant: item.variant_title || 'NA',
                            price: p > 1000 ? p / 100 : p,
                            quantity: item.quantity || 1
                        };
                    });

                    // GA4 purchase — wrapped by dedup guard defined earlier in this script
                    try {
                        if (window.GA4Events && typeof GA4Events.purchase === 'function') {
                            GA4Events.purchase({
                                transaction_id: orderId,
                                value: revenue,
                                tax: 0,
                                shipping: 0,
                                currency: currency,
                                coupon: coupon,
                                affiliation: 'GoKwik',
                                items: lineItems,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}

                    // MoEngage order confirmation events
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            var moeBase = {
                                'Order ID': orderId,
                                'Order Total': revenue,
                                'Payment Method': paymentMethod,
                                'Currency': currency,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            };
                            Moengage.track_event('purchase', moeBase);
                            // Moengage.track_event('Order placed',    moeBase);
                            // Moengage.track_event('Order Success',   moeBase);
                            // Moengage.track_event('Order Completed', moeBase);
                        }
                    } catch (e) {}
                }

                // ── Payment method selected ───────────────────────────────────────────
                if (/payment_method_select|select_payment|payment_option/.test(evtType)) {
                    var pmCartTotal = parseFloat(payload.total_price || payload.totalPrice || payload.amount || 0) / 100;
                    var pmMethod = payload.payment_method || payload.paymentMethod || payload.mode || 'NA';
                    var pmCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
                    // MoEngage
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('Payment_Method_Selected_GK', {
                                'Payment Method': pmMethod,
                                'Cart Total': pmCartTotal,
                                'Currency': pmCurrency,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                    // GA4 checkout_payment_initiated — pushed directly to dataLayer
                    try {
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: 'checkout_payment_initiated',
                                payment_method: pmMethod,
                                cart_value: pmCartTotal,
                                currency: pmCurrency,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }

                // ── Payment complete ──────────────────────────────────────────────────
                if (/payment_complete/.test(evtType)) {
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('Payment_Complete_GK', {
                                'Order ID': String(payload.order_id || payload.orderId || 'unknown'),
                                'Payment Method': payload.payment_method || payload.paymentMethod || 'NA',
                                'Order Total': parseFloat(payload.total_price || payload.totalPrice || payload.amount || 0) / 100,
                                'Currency': (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }

                // ── Checkout abandoned / exit ─────────────────────────────────────────
                if (/checkout_exit|checkout_closed|checkout_abandon/.test(evtType)) {
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('checkout_abandoned', {
                                'Cart Total': parseFloat(payload.total_price || payload.totalPrice || payload.amount || 0) / 100,
                                'Last Step Reached': payload.last_step || payload.lastStep || 'unknown',
                                'Payment Method': payload.payment_method || payload.paymentMethod || 'NA',
                                'Currency': (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }

            } catch (e) {}
        });
        // PURCHASE COD CONFIRMED EVENT
        // Fires only for COD orders from GoKwik

        (function() {

            // Prevent duplicate purchase firing
            if (window.__purchaseCODTracked) return;
            window.__purchaseCODTracked = true;

            // Detect Thank You / Order Status Page
            if (
                !window.location.pathname.includes('/thank_you') &&
                !window.location.pathname.includes('/orders/')
            ) {
                return;
            }

            // Shopify Checkout Object
            if (
                !window.Shopify ||
                !Shopify.checkout
            ) {
                return;
            }

            var checkout = Shopify.checkout;

            // PAYMENT METHOD CHECK
            var gateway =
                (checkout.gateway || '').toLowerCase();

            // Detect COD
            var isCOD =
                gateway.includes('cod') ||
                gateway.includes('cash') ||
                gateway.includes('cash on delivery');

            if (!isCOD) return;

            // ITEMS
            var items = (checkout.line_items || []).map(function(item) {
                return {
                    item_id: String(item.variant_id || item.product_id),
                    item_name: item.title || 'NA',
                    price: Number(item.price || 0),
                    quantity: item.quantity || 1
                };
            });
            // PAYLOAD
            var payload = {
                event: 'purchase_cod_confirmed_old',
                transaction_id: checkout.order_id ||
                    checkout.order_number ||
                    'NA',
                order_id: checkout.order_id ||
                    checkout.order_number ||
                    'NA',
                revenue: Number(checkout.total_price || 0),
                currency: checkout.currency || 'INR',
                payment_method: 'cod',
                city: checkout.shipping_address?.city || 'NA',
                pincode: checkout.shipping_address?.zip || 'NA',
                item_count: items.length,
                items: items,
                // IMPORTANT
                exclude_from_roas: true,
                session_id: getSessionId(),
                page_url: window.location.href,
                page_title: document.title,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };

            // GTM / GA4
            try {
                window.dataLayer.push(payload);
            } catch (err) {
                console.log(err);
            }

            // MOENGAGE
            try {

                if (
                    window.Moengage &&
                    typeof Moengage.track_event === 'function'
                ) {

                    Moengage.track_event(
                        'purchase_cod_confirmed_old', {
                            order_id: payload.order_id,
                            revenue: payload.revenue,
                            payment_method: 'cod',
                            city: payload.city,
                            pincode: payload.pincode,
                            currency: payload.currency,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        }
                    );
                }
            } catch (err) {
                console.log(err);
            }

        })();

        // ─────────────────────────────────────────────
// purchase_prepaid + purchase_cod_confirmed
// Shopify Order Success Page Tracking
// Works with GoKwik Checkout Redirect
// ─────────────────────────────────────────────

(function () {

  // Prevent duplicate firing
  if (sessionStorage.getItem('purchase_event_fired')) {
    return;
  }

  // Only order success page
  var isOrderPage =
    window.location.pathname.indexOf('/orders/') !== -1;

  if (!isOrderPage) return;

  function waitForCheckout() {

    var checkout =
      window.Shopify?.checkout ||
      window.ShopifyCheckout ||
      null;

    if (!checkout) {
      setTimeout(waitForCheckout, 1000);
      return;
    }

    // Payment gateway
    var gateway = (
      checkout.gateway ||
      checkout.payment_gateway ||
      ''
    ).toLowerCase();

    // Order Data
    var orderId =
      checkout.order_id ||
      checkout.order_number ||
      '';

    var revenue = parseFloat(
      checkout.total_price ||
      checkout.total_price_amount ||
      0
    );

    var transactionId =
      checkout.transaction_id ||
      orderId;

    var couponCode =
      checkout.discount?.code ||
      checkout.discount_code ||
      '';

    var city =
      checkout.billing_address?.city ||
      checkout.shipping_address?.city ||
      '';

    var pincode =
      checkout.billing_address?.zip ||
      checkout.shipping_address?.zip ||
      '';

    var commonPayload = {

      order_id: orderId,

      revenue: revenue,

      payment_method: gateway,

      transaction_id: transactionId,

      coupon_code: couponCode,

      city: city,

      pincode: pincode,

      currency: checkout.currency || 'INR',

      page_url: window.location.href,

      ...getUTM(),
      ...getCustomer(),

      is_new_user:
        !localStorage.getItem("visited_before")
    };

    // ─────────────────────────────
    // COD ORDER
    // ─────────────────────────────

    var isCOD =
      gateway.includes('cod') ||
      gateway.includes('cash on delivery');

    if (isCOD) {

      sessionStorage.setItem(
        'purchase_event_fired',
        'true'
      );

      var codPayload = {
        event: 'purchase_cod_confirmed',
        ...commonPayload
      };

      // GTM / GA4
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(codPayload);

      // MoEngage
      try {
        if (
          window.Moengage &&
          typeof Moengage.track_event === 'function'
        ) {
          Moengage.track_event(
            'purchase_cod_confirmed',
            codPayload
          );
        }
      } catch (e) {}

      console.log(
        'purchase_cod_confirmed fired',
        codPayload
      );

      return;
    }

    // ─────────────────────────────
    // PREPAID ORDER
    // ─────────────────────────────

    var isPrepaid =
      gateway.includes('upi') ||
      gateway.includes('razorpay') ||
      gateway.includes('paytm') ||
      gateway.includes('wallet') ||
      gateway.includes('card') ||
      gateway.includes('netbanking') ||
      gateway.includes('prepaid');

    if (isPrepaid) {

      sessionStorage.setItem(
        'purchase_event_fired',
        'true'
      );

      var prepaidPayload = {
        event: 'purchase_prepaid',
        ...commonPayload
      };

      // GTM / GA4
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(prepaidPayload);

      // MoEngage
      try {
        if (
          window.Moengage &&
          typeof Moengage.track_event === 'function'
        ) {
          Moengage.track_event(
            'purchase_prepaid',
            prepaidPayload
          );
        }
      } catch (e) {}

      console.log(
        'purchase_prepaid fired',
        prepaidPayload
      );
    }

  }

  waitForCheckout();

})();
        // ════════════════════════════════════════════════════════════════════
        // CUSTOM CLICK / SCROLL / FORM EVENTS — added via theme.liquid
        // ════════════════════════════════════════════════════════════════════

        // ── newsletter_subscribed (P2) ────────────────────────────────────
        // Fires when the customer submits any newsletter/email-signup form.
        // Captures source location (popup, footer, or page) and email address.
        document.addEventListener('submit', function(e) {
            var form = e.target.closest('form[is="newsletter-form"], form[id^="ContactSubscribe-"]');
            if (!form) return;
            var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
            var email = emailInput ? (emailInput.value || '').trim() : '';
            var source = form.closest('[id*="popup"], [class*="popup"]') ? 'popup' :
                form.closest('.footer, footer') ? 'footer' :
                'page';
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('newsletter_subscribed', {
                        'Subscription Type': 'email',
                        'Source Location': source,
                        'Email': email,
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'newsletter_subscribed',
                        subscription_type: 'email',
                        source_location: source,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── upsell_add_to_cart (P2) ───────────────────────────────────────
        // Fires when the customer clicks an ATC button inside the related-
        // products / save-more-with upsell widgets.
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.product-card__atc');
            if (!btn) return;
            var upsellSection = btn.closest('.section--related-products, .save-more-with');
            if (!upsellSection) return;
            var card = btn.closest('[data-product-id], .product-card, .product-card__wrapper');
            var productId = card ? (card.dataset.productId || card.dataset.variantId || '') : '';
            var _nameEl = card ? card.querySelector('.product-card__title, .card__title') : null;
            var productName = btn.dataset.productTitle || (card ? (card.dataset.productTitle || (_nameEl ? _nameEl.textContent.trim() : '')) : '');
            var price = parseFloat(btn.dataset.price || btn.dataset.variantPrice || 0) / 100 || 0;
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('upsell_add_to_cart', {
                        'Product ID': productId,
                        'Product Name': productName,
                        'Price': price,
                        'Section': upsellSection.className.indexOf('related') !== -1 ? 'related_products' : 'save_more_with',
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'upsell_add_to_cart',
                        product_id: productId,
                        product_name: productName,
                        price: price,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── bundle_added_to_cart (P2) ─────────────────────────────────────
        // Fires when the customer adds a product from inside a bundle widget.
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.product-card__atc, [data-bundle-atc], .bundle-atc, button[name="add"]');
            if (!btn) return;
            var bundleSection = btn.closest('.products-bundle, [data-section-type="products-bundle"]');
            if (!bundleSection) return;
            var card = btn.closest('[data-product-id], .product-card, .bundle-item');
            var productId = card ? (card.dataset.productId || card.dataset.variantId || '') : '';
            var productName = btn.dataset.productTitle || '';
            var price = parseFloat(btn.dataset.price || 0) / 100 || 0;
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('bundle_added_to_cart', {
                        'Product ID': productId,
                        'Product Name': productName,
                        'Price': price,
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'bundle_added_to_cart',
                        product_id: productId,
                        product_name: productName,
                        price: price,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── return_initiated (P2) ─────────────────────────────────────────
        // Fires when the customer clicks the Cancel / Return order button on
        // the account orders page (.coc-cancel-button).
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.coc-cancel-button, [data-return-button]');
            if (!btn) return;
            var orderId = btn.dataset.orderId || btn.closest('[data-order-id]') && btn.closest('[data-order-id]').dataset.orderId || '';
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('return_initiated', {
                        'Order ID': orderId,
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'return_initiated',
                        order_id: orderId,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── upsell_viewed (P3) ────────────────────────────────────────────
        // Fires (once per page) when a related-products or save-more-with
        // section scrolls into the viewport.
        (function() {
            if (!window.IntersectionObserver) return;
            var _upsellFired = false;
            var obs = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting || _upsellFired) return;
                    _upsellFired = true;
                    obs.disconnect();
                    var sectionType = entry.target.classList.contains('save-more-with') ? 'save_more_with' : 'related_products';
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('upsell_viewed', {
                                'Section Type': sectionType,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                    try {
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'upsell_viewed',
                                section_type: sectionType,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                });
            }, {
                threshold: 0.3
            });
            document.querySelectorAll('.section--related-products, .save-more-with').forEach(function(el) {
                obs.observe(el);
            });
        })();

        // ── bundle_viewed (P3) ────────────────────────────────────────────
        // Fires (once per page) when a products-bundle section enters the
        // viewport — or immediately if the template slug contains "bundle".
        (function() {
            var _bundleViewFired = false;

            function _fireBundleViewed() {
                if (_bundleViewFired) return;
                _bundleViewFired = true;
                var productHandle = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.handle) || '';
                try {
                    if (window.Moengage && typeof Moengage.track_event === 'function') {
                        Moengage.track_event('bundle_viewed', {
                            'Product Handle': productHandle,
                            'URL': window.location.href,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'bundle_viewed',
                            product_handle: productHandle,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
            }
            // Immediate fire if URL or template suggests a bundle product
            var url = window.location.pathname.toLowerCase();
            var isBundleProduct =
            url.indexOf('bundle') !== -1 ||
            url.indexOf('duo') !== -1 ||
            url.indexOf('essentials') !== -1 ||
            url.indexOf('set') !== -1 ||
            url.indexOf('combo') !== -1;

            if (isBundleProduct) {
                _fireBundleViewed();
            } else if (window.IntersectionObserver) {
                var bundleEls = document.querySelectorAll('.products-bundle, [data-section-type="products-bundle"]');
                if (bundleEls.length) {
                    var bObs = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                _fireBundleViewed();
                                bObs.disconnect();
                            }
                        });
                    }, {
                        threshold: 0.2
                    });
                    bundleEls.forEach(function(el) {
                        bObs.observe(el);
                    });
                }
            }
        })();
        // BUNDLE ADDED TO CART
        // Fires when Add To Cart clicked on bundle/duo/combo/set PDP

        (function () {

        // Detect Bundle Product
        var url = window.location.pathname.toLowerCase();

        var isBundleProduct =
            /(?:bundle|duo|essentials|set|combo)/i.test(url);

        if (!isBundleProduct) return;

        // Listen Add To Cart
        document.addEventListener(
            'click',
            function (e) {

            // Shopify Add To Cart Buttons
            const btn = e.target.closest(
                'button[name="add"], \
                .product-form__submit, \
                .add-to-cart, \
                [data-add-to-cart]'
            );

            if (!btn) return;

            // PRODUCT DATA
            var product =
                (window.ShopifyAnalytics &&
                ShopifyAnalytics.meta &&
                ShopifyAnalytics.meta.product)
                || {};

            // BUNDLE ID
            var bundleId =
                String(product.id || 'NA');

            // BUNDLE NAME
            var bundleName =
                product.vendor
                ? product.vendor + ' - ' + product.productName
                : (product.productName || document.title);

            // PRICE
            var bundlePrice =
                parseFloat(
                (
                    product.variants &&
                    product.variants[0] &&
                    product.variants[0].price
                ) || 0
                );

            // CONSTITUENT SKUS
            let constituentSkus = [];

            // Try extracting bundled product IDs/SKUs
            document.querySelectorAll(
                '[data-bundle-sku], \
                [data-product-id], \
                .bundle-product'
            ).forEach(function (el) {

                let sku =
                el.dataset.bundleSku ||
                el.dataset.productId ||
                '';

                if (
                sku &&
                constituentSkus.indexOf(sku) === -1
                ) {
                constituentSkus.push(sku);
                }

            });

            // FALLBACK
            if (!constituentSkus.length) {

                constituentSkus.push(bundleId);

            }

            // PAYLOAD
            var payload = {
                event: 'bundle_added_to_cart',

                bundle_id: bundleId,
                bundle_name: bundleName,

                constituent_skus: constituentSkus,

                bundle_price: bundlePrice,

                session_id: getSessionId(),

                page_url: window.location.href,
                page_title: document.title,

                ...getUTM(),
                ...getCustomer(),

                is_new_user:
                !localStorage.getItem("visited_before")
            };

            // DATALAYER
            window.dataLayer =
                window.dataLayer || [];

            window.dataLayer.push(payload);

            console.log(
                'bundle_added_to_cart fired',
                payload
            );

            // OPTIONAL GA4 ADD_TO_CART
            try {

                window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'INR',
                    value: bundlePrice,
                    items: [{
                    item_id: bundleId,
                    item_name: bundleName,
                    item_category: 'Bundle',
                    price: bundlePrice,
                    quantity: 1
                    }]
                }
                });

            } catch (e) {}

            // MOENGAGE
            try {

                if (
                window.Moengage &&
                typeof Moengage.track_event === 'function'
                ) {

                Moengage.track_event(
                    'bundle_added_to_cart',
                    {
                    'Bundle ID': bundleId,
                    'Bundle Name': bundleName,
                    'Constituent SKUs':
                        constituentSkus.join(','),
                    'Bundle Price': bundlePrice,
                    'URL': window.location.href,

                    ...getUTM(),
                    ...getCustomer(),

                    is_new_user:
                        !localStorage.getItem(
                        "visited_before"
                        )
                    }
                );

                }

            } catch (e) {}

            },
            true
        );

        })();
        // ── search_initiated and search_query_submitted (P3) ─────────────────────────────────────────
        // Fires when the customer opens the search drawer/modal.
        // Search Initiated Event
        document.addEventListener('click', function(e) {

            if (
                !e.target.closest(
                    '.search-drawer-button, .search-modal-button, [data-search-toggle]'
                )
            ) return;

            // COMMON PAYLOAD
            var payload = {
                event: 'search_initiated',
                session_id: getSessionId(),
                page_url: window.location.href,
                page_title: document.title,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            // GTM / GA4
            try {
                window.dataLayer.push(payload);
            } catch (err) {
                console.log(err);
            }
            // MoEngage
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {

                    Moengage.track_event('search_initiated', {
                        session_id: payload.session_id,
                        URL: payload.page_url,
                        page_title: payload.page_title,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });

                    console.log("MoEngage Event Fired");
                }
            } catch (err) {
                console.log(err);
            }

        }, true);
        // SEARCH RESULT CLICKED EVENT

        document.addEventListener(
            "click",
            function(e) {

                // SEARCH RESULT PRODUCT LINK
                const product = e.target.closest(
                    '.predictive-search__list-item a, \
                .search-results a, \
                .search-result-item a, \
                .grid-product a, \
                .product-card a'
                );

                if (!product) return;

                // GET ACTIVE SEARCH TERM
                let searchInput =
                    document.querySelector('input[type="search"]') ||
                    document.querySelector('input[name="q"]') ||
                    document.querySelector('.search__input');

                let searchTerm =
                    searchInput ? searchInput.value.trim() : "";

                // PRODUCT URL
                let productUrl = product.href || "";

                // PRODUCT ID
                let productId =
                    product.dataset.productId ||
                    product.closest('[data-product-id]')?.dataset.productId ||
                    productUrl.split('/products/')[1]?.split('?')[0] ||
                    "NA";

                // PRODUCT NAME
                let productName =
                    product.dataset.productTitle ||
                    product.querySelector('.card__heading')?.innerText ||
                    product.querySelector('.predictive-search__item-heading')?.innerText ||
                    product.innerText.trim() ||
                    "NA";

                // RESULT POSITION
                let allResults = document.querySelectorAll(
                    '.predictive-search__list-item a, \
                .search-results a, \
                .search-result-item a, \
                .grid-product a, \
                .product-card a'
                );

                let resultPosition =
                    Array.from(allResults).indexOf(product) + 1;

                // PAYLOAD
                var payload = {
                    event: "search_result_clicked",

                    search_term: searchTerm,
                    product_id: productId,
                    product_name: productName,
                    result_position: resultPosition,

                    destination_url: productUrl,

                    session_id: getSessionId(),
                    page_url: window.location.href,
                    page_title: document.title,

                    ...getUTM(),
                    ...getCustomer(),
                    is_new_user: !localStorage.getItem("visited_before")
                };

                // GTM / GA4
                try {
                    window.dataLayer.push(payload);

                    console.log("DataLayer Event:", payload);

                } catch (err) {
                    console.log(err);
                }

                // MOENGAGE
                try {

                    if (
                        window.Moengage &&
                        typeof Moengage.track_event === "function"
                    ) {

                        Moengage.track_event("search_result_clicked", {

                            search_term: payload.search_term,
                            product_id: payload.product_id,
                            product_name: payload.product_name,
                            result_position: payload.result_position,

                            URL: payload.page_url,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });

                        console.log("MoEngage Event Fired");
                    }

                } catch (err) {
                    console.log(err);
                }

            },
            true
        );
        // SEARCH SUBMITTED EVENT
        document.addEventListener(
            "submit",
            function(e) {

                // SEARCH FORM SELECTORS
                const form = e.target.closest(
                    'form[action*="/search"], .search-form, form[role="search"]'
                );

                if (!form) return;

                // GET SEARCH TERM
                let searchInput =
                    form.querySelector('input[type="search"]') ||
                    form.querySelector('input[name="q"]') ||
                    form.querySelector('.search__input');

                let searchTerm = searchInput ? searchInput.value.trim() : "";

                if (!searchTerm) return;

                // OPTIONAL RESULT COUNT
                let resultCount =
                    document.querySelectorAll(
                        '.product-card, .search-result-item, .grid-product'
                    ).length || 0;

                // PAYLOAD
                var payload = {
                    event: "search_query_submitted",
                    search_term: searchTerm,
                    result_count: resultCount,
                    session_id: getSessionId(),
                    page_url: window.location.href,
                    page_title: document.title,
                    ...getUTM(),
                    ...getCustomer(),
                    is_new_user: !localStorage.getItem("visited_before")
                };

                // GTM / GA4
                try {
                    window.dataLayer.push(payload);
                } catch (err) {
                    console.log(err);
                }

                // MoEngage
                try {
                    if (
                        window.Moengage &&
                        typeof Moengage.track_event === "function"
                    ) {

                        Moengage.track_event("search_query_submitted", {
                            search_term: payload.search_term,
                            result_count: payload.result_count,
                            session_id: payload.session_id,
                            URL: payload.page_url,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            true
        );

        // ── check_delivery_clicked (P3) ───────────────────────────────────
        // Fires when the customer changes the pincode in the delivery checker
        // or clicks a "Check Delivery" / "Check Availability" button.
        (function() {
            var _pincodeEl = document.querySelector('#PostalCode, #PinCodSelect, #pincode-input, input[name="PostalCode"], input[name="pincode"], input[placeholder*="pincode" i], input[placeholder*="PIN" i]');
            if (_pincodeEl) {
                _pincodeEl.addEventListener('change', function() {
                    var pincode = (_pincodeEl.value || '').trim();
                    if (!pincode) return;
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('check_delivery_clicked', {
                                'Pincode': pincode,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                    try {
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'check_delivery_clicked',
                                pincode: pincode,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                });
            }
            // Also catch explicit "Check" button clicks near the pincode widget
            document.addEventListener('click', function(e) {
                var btn = e.target.closest('#submitButton, .check-button, [data-pincode-check], .pincode-check-btn, .check-delivery-btn, button[class*="pincode"], button[class*="delivery"]');
                if (!btn) return;
                var wrapper = btn.closest('.pincode-checker, .product__block--pincode-checker, [data-section-type="pincode-checker"], form');
                var pinInput = wrapper ? wrapper.querySelector('#PostalCode, input[type="text"], input[type="number"], select') : null;
                var pincode = pinInput ? (pinInput.value || '').trim() : '';
                try {
                    if (window.Moengage && typeof Moengage.track_event === 'function') {
                        Moengage.track_event('check_delivery_clicked', {
                            'Pincode': pincode,
                            'URL': window.location.href,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'check_delivery_clicked',
                            pincode: pincode,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
            }, true);
        })();

        // ── track_order_clicked (P3) ──────────────────────────────────────
        // Fires when the customer clicks a "Track Order" link on the account page.
        document.addEventListener('click', function(e) {
            var link = e.target.closest('.track-order-link, [data-track-order], a[href*="track"]');
            if (!link) return;
            var row = link.closest('tr, [data-order-id], .order-row');
            var idInput = row ? row.querySelector('.order-id, input[name="order_id"]') : null;
            var orderId = (idInput && idInput.value) || (row && row.dataset.orderId) || '';
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('track_order_clicked', {
                        'Order ID': orderId,
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'track_order_clicked',
                        order_id: orderId,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── logout (P4) ───────────────────────────────────────────────────
        // Fires when the customer clicks the logout link.
        document.addEventListener('click', function(e) {
            if (!e.target.closest('a[href*="account/logout"], a[href*="logout"]')) return;
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('logout', {
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'logout',
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);
// VIEW PDP EVENT
// GA4 Alias: view_pdp

(function () {

  // ONLY PDP
  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  // Prevent duplicate firing
  if (window.__viewPDPTracked) return;
  window.__viewPDPTracked = true;

  // FETCH PRODUCT JSON
  fetch(window.location.pathname + '.js')
    .then(function (r) {
      return r.json();
    })
    .then(function (product) {

      // PRODUCT DATA
      var productId =
        String(product.id || 'NA');

      var productName =
        product.title || 'NA';

      var category =
        product.type || 'NA';

      var subCategory =
        (product.tags && product.tags[0]) || 'NA';

      var price =
        ((product.price || 0) / 100);

      var variantId =
        product.variants &&
        product.variants[0] ?
        String(product.variants[0].id) :
        'NA';

      // SOURCE DETECTION
      let source = 'direct';

      const referrer =
        document.referrer || '';

      if (referrer.includes('/search')) {
        source = 'search';
      }
      else if (referrer.includes('/collections/')) {
        source = 'collection';
      }
      else if (
        referrer === window.location.origin + '/' ||
        referrer === window.location.origin
      ) {
        source = 'homepage';
      }

      // GA4 ITEM
      var ecommerce = {
        currency: 'INR',
        value: price,
        items: [{
          item_id: productId,
          item_name: productName,
          item_category: category,
          item_category2: subCategory,
          price: price,
          item_variant: variantId
        }]
      };

      // PAYLOAD
      var payload = {
        event: 'view_pdp',

        product_id: productId,
        product_name: productName,
        category: category,
        sub_category: subCategory,
        price: price,
        variant_id: variantId,
        source: source,

        ecommerce: ecommerce,

        session_id: getSessionId(),

        page_url: window.location.href,
        page_title: document.title,

        ...getUTM(),
        ...getCustomer()
      };

      // DATALAYER PUSH
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      // OPTIONAL GA4 STANDARD EVENT
      window.dataLayer.push({
        event: 'view_pdp',
        ecommerce: ecommerce,
        ...getUTM(),
        ...getCustomer(),
        is_new_user: !localStorage.getItem("visited_before")
      });

      console.log(
        'view_pdp fired',
        payload
      );

      // MOENGAGE
      try {

        if (
          window.Moengage &&
          typeof Moengage.track_event === 'function'
        ) {

          Moengage.track_event(
            'view_pdp',
            {
              product_id: productId,
              product_name: productName,
              category: category,
              sub_category: subCategory,
              price: price,
              variant_id: variantId,
              source: source,
              URL: window.location.href
            }
          );

        }

      } catch (e) {}

    })
    .catch(function (e) {
      console.log('view_pdp error', e);
    });

})();

        // NOTE: concern_nav_clicked is already implemented in
        // sections/collection-list.liquid as the 'shop_by_concern' MoEngage event.

        // ════════════════════════════════════════════════════════════════════
        // PENDING CUSTOM IMPLEMENTATION EVENTS (24 events)
        // ════════════════════════════════════════════════════════════════════

        // ── Synthetic session-state helpers ───────────────────────────────
        // Used by pdp_to_cart_conversion and cart_to_checkout_conversion
        var _synthState = {
            pdp: null,
            cart: null
        };

        // Hook into existing dataLayer pushes to detect view_pdp and view_cart
        // (These fire from datalayer.js / GA4Events already)
        // (function() {
        //     var _origPush = window.dataLayer && window.dataLayer.push ?
        //         window.dataLayer.push.bind(window.dataLayer) :
        //         null;
        //     if (!_origPush) return;
        //     window.dataLayer.push = function() {
        //         var args = Array.prototype.slice.call(arguments);
        //         try {
        //             var obj = args[0];
        //             if (obj && typeof obj === 'object') {
        //                 // Track view_pdp → record which PDP the customer viewed
        //                 if (obj.event === 'view_pdp' && obj.ecommerce && obj.ecommerce.items && obj.ecommerce.items[0]) {
        //                     var itm = obj.ecommerce.items[0];
        //                     _synthState.pdp = {
        //                         productId: String(itm.item_id || itm.id || ''),
        //                         productName: String(itm.item_name || itm.name || ''),
        //                         price: parseFloat(itm.price || 0),
        //                         ts: Date.now()
        //                     };
        //                 }
        //                 // Track view_cart → record cart state
        //                 if (obj.event === 'view_cart' || obj.event === 'cart_viewed') {
        //                     _synthState.cart = {
        //                         cartTotal: parseFloat(obj.cart_total || (obj.ecommerce && obj.ecommerce.value) || 0),
        //                         ts: Date.now()
        //                     };
        //                 }
        //                 // Detect add_to_cart → fire pdp_to_cart_conversion if PDP was viewed first
        //                 if (obj.event === 'add_to_cart' && _synthState.pdp) {
        //                     var addedId = String(
        //                         (obj.ecommerce && obj.ecommerce.items && obj.ecommerce.items[0] && (obj.ecommerce.items[0].item_id || obj.ecommerce.items[0].id)) || ''
        //                     );
        //                     if (!addedId || addedId === _synthState.pdp.productId) {
        //                         var secsPdp = Math.round((Date.now() - _synthState.pdp.ts) / 1000);
        //                         var _p = {
        //                             'Product ID': _synthState.pdp.productId,
        //                             'Product Name': _synthState.pdp.productName,
        //                             'Price': _synthState.pdp.price,
        //                             'Time to Add (secs)': secsPdp,
        //                             'Value': _synthState.pdp.price,
        //                             'Currency': 'INR',
        //                             'URL': window.location.href,
        //                             ...getUTM(),
        //                             ...getCustomer(),
        //                             is_new_user: !localStorage.getItem("visited_before")
        //                         };
        //                         try {
        //                             if (window.Moengage && typeof Moengage.track_event === 'function') {
        //                                 Moengage.track_event('pdp_to_cart_conversion', _p);
        //                             }
        //                         } catch (e) {}
        //                         try {
        //                             window.dataLayer && _origPush({
        //                                 event: 'pdp_to_cart_conversion',
        //                                 product_id: _p['Product ID'],
        //                                 product_name: _p['Product Name'],
        //                                 time_to_add_seconds: secsPdp,
        //                                 ...getUTM(),
        //                                 ...getCustomer(),
        //                                 is_new_user: !localStorage.getItem("visited_before")
        //                             });
        //                         } catch (e) {}
        //                         _synthState.pdp = null; // reset after firing
        //                     }
        //                 }
        //                 // Detect begin_checkout → fire cart_to_checkout_conversion if cart was viewed first
        //                 if (obj.event === 'begin_checkout' && _synthState.cart) {
        //                     var secsCart = Math.round((Date.now() - _synthState.cart.ts) / 1000);
        //                     var _c = {
        //                         'Cart Total': _synthState.cart.cartTotal,
        //                         'Time to Checkout (secs)': secsCart,
        //                         'Currency': 'INR',
        //                         'URL': window.location.href,
        //                         ...getUTM(),
        //                         ...getCustomer(),
        //                         is_new_user: !localStorage.getItem("visited_before")
        //                     };
        //                     try {
        //                         if (window.Moengage && typeof Moengage.track_event === 'function') {
        //                             Moengage.track_event('cart_to_checkout_conversion', _c);
        //                         }
        //                     } catch (e) {}
        //                     try {
        //                         _origPush({
        //                             event: 'cart_to_checkout_conversion',
        //                             cart_total: _c['Cart Total'],
        //                             time_to_checkout_seconds: secsCart
        //                         });
        //                     } catch (e) {}
        //                     _synthState.cart = null;
        //                 }
        //             }
        //         } catch (e) {}
        //         return _origPush.apply(window.dataLayer, args);
        //     };
        // })();
        // ======================================================
        // SYNTHETIC FUNNEL EVENTS
        // view_pdp -> add_to_cart = pdp_to_cart_conversion
        // view_cart -> begin_checkout = cart_to_checkout_conversion
        // ======================================================

        window._synthState = window._synthState || {};

        (function () {

            var _origPush =
                window.dataLayer &&
                window.dataLayer.push
                    ? window.dataLayer.push.bind(window.dataLayer)
                    : null;

            if (!_origPush) return;

            window.dataLayer.push = function () {

                var args = Array.prototype.slice.call(arguments);

                try {

                    var obj = args[0];

                    if (obj && typeof obj === "object") {

                        // ======================================================
                        // STORE PDP VIEW
                        // ======================================================

                        if (
                            (obj.event === "view_pdp" || obj.event === "view_item") &&
                            obj.ecommerce &&
                            obj.ecommerce.items &&
                            obj.ecommerce.items[0]
                        ) {

                            var itm = obj.ecommerce.items[0];

                            _synthState.pdp = {
                                productId: String(itm.item_id || itm.id || ""),
                                productName: String(itm.item_name || itm.name || ""),
                                category: String(itm.item_category || ""),
                                price: parseFloat(itm.price || 0),
                                sourceSurface:
                                    obj.source ||
                                    obj.source_surface ||
                                    sessionStorage.getItem("last_source_surface") ||
                                    "direct",
                                ts: Date.now()
                            };
                        }

                        // ======================================================
                        // STORE CART VIEW
                        // ======================================================

                        if (
                            obj.event === "view_cart" ||
                            obj.event === "cart_viewed"
                        ) {

                            var itemCount = 0;

                            if (
                                obj.ecommerce &&
                                obj.ecommerce.items &&
                                Array.isArray(obj.ecommerce.items)
                            ) {
                                itemCount = obj.ecommerce.items.length;
                            }

                            _synthState.cart = {
                                cartTotal: parseFloat(
                                    obj.cart_total ||
                                    (obj.ecommerce && obj.ecommerce.value) ||
                                    0
                                ),
                                itemCount: itemCount,
                                ts: Date.now()
                            };
                        }

                        // ======================================================
                        // PDP -> CART CONVERSION
                        // ======================================================

                        if (
                            obj.event === "add_to_cart" &&
                            _synthState.pdp
                        ) {

                            var addedId = String(
                                (
                                    obj.ecommerce &&
                                    obj.ecommerce.items &&
                                    obj.ecommerce.items[0] &&
                                    (
                                        obj.ecommerce.items[0].item_id ||
                                        obj.ecommerce.items[0].id
                                    )
                                ) || ""
                            );

                            // Ensure same PDP item
                            if (
                                !addedId ||
                                addedId === _synthState.pdp.productId
                            ) {

                                var secsPdp = Math.round(
                                    (Date.now() - _synthState.pdp.ts) / 1000
                                );

                                var _p = {
                                    product_id: _synthState.pdp.productId,
                                    product_name: _synthState.pdp.productName,
                                    category: _synthState.pdp.category,
                                    price: _synthState.pdp.price,
                                    time_to_add_seconds: secsPdp,
                                    source_surface: _synthState.pdp.sourceSurface,
                                    currency: "INR",
                                    page_url: window.location.href,
                                    is_new_user:
                                        !localStorage.getItem("visited_before"),
                                    ...getUTM(),
                                    ...getCustomer()
                                };

                                // -----------------------------
                                // GA4 / DATALAYER
                                // -----------------------------

                                try {

                                    _origPush({
                                        event: "pdp_to_cart_conversion",
                                        product_id: _p.product_id,
                                        product_name: _p.product_name,
                                        category: _p.category,
                                        price: _p.price,
                                        time_to_add_seconds:
                                            _p.time_to_add_seconds,
                                        source_surface:
                                            _p.source_surface,
                                        currency: _p.currency,
                                        is_new_user:
                                            _p.is_new_user,
                                        ...getUTM(),
                                        ...getCustomer()
                                    });

                                    console.log(
                                        "DataLayer Event:",
                                        "pdp_to_cart_conversion",
                                        _p
                                    );

                                } catch (e) {
                                    console.log(e);
                                }

                                // -----------------------------
                                // MOENGAGE
                                // -----------------------------

                                try {

                                    if (
                                        window.Moengage &&
                                        typeof Moengage.track_event === "function"
                                    ) {

                                        Moengage.track_event(
                                            "pdp_to_cart_conversion",
                                            _p
                                        );

                                        console.log(
                                            "MoEngage Event Fired:",
                                            "pdp_to_cart_conversion"
                                        );
                                    }

                                } catch (e) {
                                    console.log(e);
                                }

                                // reset after conversion
                                _synthState.pdp = null;
                            }
                        }

                        // ======================================================
                        // CART -> CHECKOUT CONVERSION
                        // ======================================================

                        if (
                            obj.event === "begin_checkout" &&
                            _synthState.cart
                        ) {

                            var secsCart = Math.round(
                                (Date.now() - _synthState.cart.ts) / 1000
                            );

                            var _c = {
                                cart_total: _synthState.cart.cartTotal,
                                item_count: _synthState.cart.itemCount,
                                time_to_checkout_seconds: secsCart,
                                currency: "INR",
                                page_url: window.location.href,
                                is_new_user:
                                    !localStorage.getItem("visited_before"),
                                ...getUTM(),
                                ...getCustomer()
                            };

                            // -----------------------------
                            // GA4 / DATALAYER
                            // -----------------------------

                            try {

                                _origPush({
                                    event: "cart_to_checkout_conversion",
                                    cart_total: _c.cart_total,
                                    item_count: _c.item_count,
                                    time_to_checkout_seconds:
                                        _c.time_to_checkout_seconds,
                                    currency: _c.currency,
                                    is_new_user:
                                        _c.is_new_user,
                                    ...getUTM(),
                                    ...getCustomer()
                                });

                                console.log(
                                    "DataLayer Event:",
                                    "cart_to_checkout_conversion",
                                    _c
                                );

                            } catch (e) {
                                console.log(e);
                            }

                            // -----------------------------
                            // MOENGAGE
                            // -----------------------------

                            try {

                                if (
                                    window.Moengage &&
                                    typeof Moengage.track_event === "function"
                                ) {

                                    Moengage.track_event(
                                        "cart_to_checkout_conversion",
                                        _c
                                    );

                                    console.log(
                                        "MoEngage Event Fired:",
                                        "cart_to_checkout_conversion"
                                    );
                                }

                            } catch (e) {
                                console.log(e);
                            }

                            // reset after conversion
                            _synthState.cart = null;
                        }
                    }

                } catch (e) {
                    console.log(e);
                }

                return _origPush.apply(window.dataLayer, args);
            };

        })();

        // ======================================================
    // ======================================================
// PDP -> CART CONVERSION
// Fire ONLY when customer clicks "View Cart"
// after Add To Cart on /products/* pages
// ======================================================

(function () {

    // Only on product pages
    if (!window.location.pathname.includes('/products/')) return;

    // Store PDP visit time
    var pdpViewedAt = Date.now();

    // Store Add To Cart state
    var addToCartClicked = false;

    // Prevent duplicate event firing
    var fired = false;

    // =========================================
    // STEP 1: Detect Add To Cart click
    // =========================================

    document.addEventListener('click', function (e) {

        var atcBtn = e.target.closest(`
            button[name="add"],
            .product-form__submit,
            .add-to-cart,
            [data-add-to-cart]
        `);

        if (!atcBtn) return;

        addToCartClicked = true;

        console.log('Add To Cart Clicked');

    }, true);

    // =========================================
    // STEP 2: Detect View Cart click
    // =========================================

    document.addEventListener('click', function (e) {

        if (!addToCartClicked || fired) return;

        var viewCartBtn = e.target.closest(`
            a[href*="/cart"],
            .cart-drawer__footer a,
            .go-to-cart,
            .view-cart,
            [data-cart-view]
        `);

        if (!viewCartBtn) return;

        fired = true;

        // Shopify product data
        var productData =
            window.meta &&
            window.meta.product
                ? window.meta.product
                : {};

        // Time from PDP load → View Cart
        var secsPdp = Math.round(
            (Date.now() - pdpViewedAt) / 1000
        );

        // Source surface
        var sourceSurface =
            sessionStorage.getItem('last_source_surface') ||
            document.referrer ||
            'direct';

        // Payload
        var payload = {

            event: 'pdp_to_cart_conversion',

            product_id:
                productData.id || '',

            product_name:
                productData.title || document.title,

            product_handle:
                productData.handle || '',

            category:
                productData.type || '',

            price:
                productData.price
                    ? productData.price / 100
                    : 0,

            variant_id:
                (
                    productData.variants &&
                    productData.variants[0] &&
                    productData.variants[0].id
                ) || '',

            source_surface: sourceSurface,

            time_to_add_seconds: secsPdp,

            currency: 'INR',

            page_url: window.location.href,

            is_new_user:
                !localStorage.getItem('visited_before'),

            ...getUTM(),
            ...getCustomer()
        };

        // ====================================
        // DATALAYER EVENT
        // ====================================

        try {

            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push(payload);

            console.log(
                'DataLayer Event Fired:',
                payload
            );

        } catch (err) {
            console.log(err);
        }

        // ====================================
        // MOENGAGE EVENT
        // ====================================

        try {

            if (
                window.Moengage &&
                typeof Moengage.track_event === 'function'
            ) {

                Moengage.track_event(
                    'pdp_to_cart_conversion',
                    payload
                );

                console.log(
                    'MoEngage Event Fired'
                );
            }

        } catch (err) {
            console.log(err);
        }

    }, true);

})();
        // ─────────────────────────────────────────────
        // cart_to_checkout_conversion
        // GoKwik Popup Checkout Tracking
        // Fires when user clicks GoKwik checkout button
        // AFTER cart/sidebar viewed in same session
        // ─────────────────────────────────────────────

    (function () {

        window._synthState = window._synthState || {};

        // SAVE CART VIEW STATE
        function saveCartState() {

            const offerBox = document.querySelector("shadow-dom-container");

            if (!offerBox || !offerBox.shadowRoot) return;

            let cartTotal = 0;
            let itemCount = 0;

            // CART TOTAL
            const totalEl =
            offerBox.shadowRoot.querySelector(
                '.total-amount .estimated-total-container span[class*="svelte"]'
            );

            if (totalEl) {
            cartTotal = parseFloat(
                totalEl.innerText.replace(/[^\d.]/g, "")
            ) || 0;
            }

            // ITEM COUNT
            const headerText =
            offerBox.shadowRoot
                .querySelector('.side-cart-header p')
                ?.textContent || '';

            const match = headerText.match(/\((\d+)\)/);

            if (match && match[1]) {
            itemCount = parseInt(match[1]);
            }

            // SAVE
            window._synthState.cart = {
            cartTotal: cartTotal,
            itemCount: itemCount,
            ts: Date.now()
            };

            // OPTIONAL
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
            event: "cart_viewed",
            cart_total: cartTotal,
            item_count: itemCount,
            ...getUTM(),
            ...getCustomer(),
            is_new_user: !localStorage.getItem("visited_before")
            });

            // console.log("Cart State Saved", window._synthState.cart);
        }

        // DETECT SIDECART OPEN
        const cartObserver = new MutationObserver(() => {

            const offerBox = document.querySelector("shadow-dom-container");

            if (offerBox && offerBox.shadowRoot) {

            const sidecart =
                offerBox.shadowRoot.querySelector(".sidecart");

            if (sidecart && !sidecart.hasAttribute("cart-view-tracked")) {

                sidecart.setAttribute("cart-view-tracked", "true");

                setTimeout(saveCartState, 1000);
            }
            }
        });

        cartObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        // ATTACH CHECKOUT CLICK EVENT
        function attachCheckoutEvent() {

            const offerBox = document.querySelector("shadow-dom-container");

            if (!offerBox || !offerBox.shadowRoot) return;

            const checkoutBtn =
            offerBox.shadowRoot.querySelector(
                ".gokwik-checkout button"
            );

            if (!checkoutBtn) return;

            if (checkoutBtn.hasAttribute("checkout-event-added")) return;

            checkoutBtn.setAttribute("checkout-event-added", "true");

            checkoutBtn.addEventListener("click", function () {

            const cartState = window._synthState.cart;

            if (!cartState) return;

            const seconds =
                Math.round((Date.now() - cartState.ts) / 1000);

            const payload = {
                event: "cart_to_checkout_conversion",
                cart_total: cartState.cartTotal,
                item_count: cartState.itemCount,
                time_to_checkout_seconds: seconds,
                checkout_type: "gokwik_popup",
                page_url: window.location.href,
                page_title: document.title,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };

            // GTM / GA4
            try {

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(payload);

                console.log(
                "cart_to_checkout_conversion",
                payload
                );

            } catch (e) {
                console.log(e);
            }

            // MOENGAGE
            try {

                if (
                window.Moengage &&
                typeof Moengage.track_event === "function"
                ) {

                Moengage.track_event(
                    "cart_to_checkout_conversion",
                    {
                    cart_total: payload.cart_total,
                    item_count: payload.item_count,
                    time_to_checkout_seconds:
                        payload.time_to_checkout_seconds,
                    checkout_type: payload.checkout_type,
                    URL: payload.page_url
                    }
                );
                }

            } catch (e) {
                console.log(e);
            }

            // RESET
            window._synthState.cart = null;

            });

            // console.log("Checkout Event Attached");
        }

        // OBSERVE FOR DYNAMIC GOKWIK BUTTON
        const checkoutObserver = new MutationObserver(() => {
            attachCheckoutEvent();
        });

        checkoutObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        // FALLBACK
        setInterval(attachCheckoutEvent, 2000);

        })();
        // ── 1. nav_menu_clicked ───────────────────────────────────────────
        document.addEventListener('click', function(e) {
            var link = e.target.closest('.header__menu a, .sub-menu a, .menu-child-nav a, .menu__item a, header nav a');
            if (!link) return;
            var navItem = (link.textContent || '').trim();
            if (!navItem) return;
            var subMenu = link.closest('.sub-menu, .menu-child-nav, .sub-menu-child');
            var subItem = subMenu ? (function() {
                var heading = subMenu.previousElementSibling;
                return heading ? (heading.textContent || '').trim() : '';
            })() : '';
            var props = {
                'Nav Item': navItem,
                'Sub Item': subItem,
                'Destination URL': link.href || '',
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('nav_menu_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'nav_menu_clicked',
                        nav_item: props['Nav Item'],
                        sub_item: props['Sub Item'],
                        destination_url: props['Destination URL'],
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 2. announcement_bar_clicked ───────────────────────────────────
        document.addEventListener('click', function(e) {
            var el = e.target.closest('.announcement-bar__item--link, .announcement-bar__item, [class*="announcement"] a, [class*="announcement-bar"] button');
            if (!el) return;
            var text = (el.textContent || el.dataset.announcementText || '').trim().substring(0, 120);
            var dest = el.tagName === 'A' ? (el.href || '') : (el.closest('a') ? el.closest('a').href : '');
            var props = {
                'Announcement Text': text,
                'Destination URL': dest,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('announcement_bar_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'announcement_bar_clicked',
                        announcement_text: text,
                        destination_url: dest,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 3. product_card_viewed (MutationObserver style-reveal + IO fallback) ──
        // This theme uses an animation reveal system that starts cards at
        // visibility:hidden (inline style on the wrapper) and removes it on scroll.
        // IntersectionObserver won't fire for hidden elements, so we watch for
        // the style attribute change instead, then verify the card is in-view.
        (function() {
            var _viewedCards = new Set();

            function fireCardViewed(card) {
                if (_viewedCards.has(card)) return;
                _viewedCards.add(card);
                var allCards = document.querySelectorAll('.product-card, .f-column.card .product-card, [data-product-id]');
                var idx = Array.prototype.indexOf.call(allCards, card);
                var productId = card.dataset.productId || card.dataset.variantId || '';
                var productName = ((card.querySelector('.product-card__title, .card__title, .product__title, [class*="product-title"]') || {})).textContent || '';
                productName = productName.trim();
                var priceEl = card.querySelector('.price__sale .money, .price .money, .price, [class*="price"]');
                var price = priceEl ? parseFloat((priceEl.textContent || '0').replace(/[^0-9.]/g, '')) || 0 : 0;
                var props = {
                    'Product ID': productId,
                    'Product Name': productName,
                    'Price': price,
                    'Position in List': idx + 1,
                    'URL': window.location.href,
                    ...getUTM(),
                    ...getCustomer(),
                    is_new_user: !localStorage.getItem("visited_before")
                };
                try {
                    if (window.Moengage && typeof Moengage.track_event === 'function') {
                        Moengage.track_event('product_card_viewed', props);
                    }
                } catch (e) {}
                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'product_card_viewed',
                            product_id: productId,
                            product_name: productName,
                            position: idx + 1,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
            }

            // Strategy 1: MutationObserver on the page body watching for
            // inline style changes on .f-column.card wrappers (theme reveal animation).
            // When visibility:hidden is removed from the wrapper, the card is revealed.
            var _styleMO = new MutationObserver(function(muts) {
                muts.forEach(function(mut) {
                    if (mut.type !== 'attributes' || mut.attributeName !== 'style') return;
                    var wrapper = mut.target;
                    if (!wrapper || !wrapper.classList) return;
                    // Fire when the style is cleared / visibility becomes visible
                    var newVis = wrapper.style.visibility;
                    if (newVis === '' || newVis === 'visible') {
                        var card = wrapper.querySelector('.product-card');
                        if (card) fireCardViewed(card);
                    }
                });
            });
            // Observe all current .f-column.card wrappers for style changes
            function attachStyleObservers(root) {
                var wrappers = (root || document).querySelectorAll('.f-column.card, .card, [class*="f-column"]');
                wrappers.forEach(function(w) {
                    if (w._pcvObserved) return;
                    w._pcvObserved = true;
                    _styleMO.observe(w, {
                        attributes: true,
                        attributeFilter: ['style']
                    });
                });
            }
            attachStyleObservers(document);

            // Strategy 2: IO fallback for cards that are already visible
            // (e.g., cards without the visibility:hidden animation, or on non-collection pages)
            function observeCardIO(card) {
                if (_viewedCards.has(card)) return;
                var cs = window.getComputedStyle(card);
                // Skip if card is hidden — rely on Strategy 1
                if (cs.visibility === 'hidden') return;
                var io = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (!entry.isIntersecting) return;
                        io.disconnect();
                        fireCardViewed(entry.target);
                    });
                }, {
                    threshold: 0.3
                });
                io.observe(card);
            }

            function attachCardObserversIO(root) {
                var cards = (root || document).querySelectorAll('.product-card');
                cards.forEach(function(card) {
                    observeCardIO(card);
                });
            }
            attachCardObserversIO(document);

            // Strategy 3: MutationObserver for newly added cards (infinite scroll / pagination)
            var _gridMO = new MutationObserver(function(muts) {
                muts.forEach(function(mut) {
                    mut.addedNodes.forEach(function(node) {
                        if (node.nodeType !== 1) return;
                        var newCards = node.matches && node.matches('.product-card') ? [node] :
                            (node.querySelectorAll ? Array.from(node.querySelectorAll('.product-card')) : []);
                        newCards.forEach(function(card) {
                            observeCardIO(card);
                        });
                        // Also attach style observers to new wrappers
                        attachStyleObservers(node);
                    });
                });
            });
            var _productGrid = document.querySelector('.collection-grid, #ProductGridContainer, grid-list, .product-grid, main');
            if (_productGrid) {
                _gridMO.observe(_productGrid, {
                    childList: true,
                    subtree: true
                });
            }
        })();

        // ── 4. search_result_clicked ──────────────────────────────────────
        document.addEventListener('click', function(e) {
            var link = e.target.closest('#predictive-search a, .predictive-search a, .search-modal a[href*="/products/"], .search-drawer a[href*="/products/"]');
            if (!link) return;
            var searchInput = document.querySelector('input[name="q"], .search__input, #Search-In-Modal, #Search-In-Drawer, input[type="search"]');
            var searchTerm = searchInput ? (searchInput.value || '').trim() : '';
            var productName = (link.querySelector('[class*="title"], [class*="name"], strong') || link).textContent.trim().substring(0, 100);
            var productUrl = link.href || '';
            var props = {
                'Search Term': searchTerm,
                'Product Name': productName,
                'Product URL': productUrl,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('search_result_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'search_result_clicked',
                        search_term: searchTerm,
                        product_name: productName,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 5. view_all_clicked ───────────────────────────────────────────
        document.addEventListener('click', function(e) {
            var link = e.target.closest('a[href*="/collections"], a[href*="/all"], .view-all, [class*="view-all"], [class*="btn--primary"]');
            if (!link) return;
            var text = (link.textContent || '').trim().toLowerCase();
            // Must have a collection destination AND match view-all/shop-now type text, or explicit class
            var isViewAll = text.indexOf('view all') !== -1 || text.indexOf('see all') !== -1 || text.indexOf('shop all') !== -1;
            var isShopNow = (text === 'shop now' || text === 'explore' || text === 'browse all') && link.href && link.href.indexOf('/collections') !== -1;
            var hasClass = link.matches('.view-all, [class*="view-all"]');
            if (!isViewAll && !isShopNow && !hasClass) return;
            var sectionEl = link.closest('[class*="section"], [data-section-id], .featured-collection, [class*="featured"]');
            var sectionName = sectionEl ? (sectionEl.dataset.sectionId || sectionEl.className.replace(/section--|featured-/g, '').split(' ')[0]) : '';
            var collUrl = link.href || '';
            var props = {
                'Section Name': sectionName,
                'Collection URL': collUrl,
                'Link Text': (link.textContent || '').trim(),
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('view_all_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'view_all_clicked',
                        section_name: sectionName,
                        collection_url: collUrl,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 6. faq_clicked ────────────────────────────────────────────────
        document.addEventListener('click', function(e) {
            var summary = e.target.closest('[pdpfaqmain], .accordion-details__summary, .accordion__title, details > summary, [class*="faq"] summary, [class*="faq"] button, [data-accordion]');
            if (!summary) return;
            var question = (summary.textContent || '').trim().substring(0, 150);
            var details = summary.closest('details, .accordion-details, [class*="accordion"]');
            var isOpen = details ? details.hasAttribute('open') : false;
            var props = {
                'Question': question,
                'Action': isOpen ? 'close' : 'open',
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('faq_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'faq_clicked',
                        question: question,
                        action: props['Action'],
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 7. review_section_viewed (IntersectionObserver) ───────────────
        (function() {
            var _reviewFired = false;
            var reviewSel = '.nector-review-widget, [class*="review-widget"], .reviews-section, #shopify-product-reviews, [class*="reviews"], .spr-container, [id*="review"]';

            function initReviewObserver() {
                var reviewEl = document.querySelector(reviewSel);
                if (!reviewEl) return;
                var io = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (!entry.isIntersecting || _reviewFired) return;
                        _reviewFired = true;
                        io.disconnect();
                        var props = {
                            'Product ID': (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && String(window.ShopifyAnalytics.meta.product.id)) || '',
                            'URL': window.location.href,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        };
                        try {
                            if (window.Moengage && typeof Moengage.track_event === 'function') {
                                Moengage.track_event('review_section_viewed', props);
                            }
                        } catch (e) {}
                        try {
                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    event: 'review_section_viewed',
                                    product_id: props['Product ID'],
                                    ...getUTM(),
                                    ...getCustomer(),
                                    is_new_user: !localStorage.getItem("visited_before")
                                });
                            }
                        } catch (e) {}
                    });
                }, {
                    threshold: 0.2
                });
                io.observe(reviewEl);
            }
            initReviewObserver();
            // Retry after a short delay for sections loaded via JS
            setTimeout(initReviewObserver, 2000);
        })();

        // ── 8. pack_section_viewed (IntersectionObserver) ─────────────────
        (function() {
            var _packFired = false;

            function initPackObserver() {
                var packEl = document.querySelector('.variantsSelector, .product__block--product-as-variant, .vm-custom-prod-as-var, [class*="pack-selector"], [class*="variant-selector"]');
                if (!packEl) return;
                var io = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (!entry.isIntersecting || _packFired) return;
                        _packFired = true;
                        io.disconnect();
                        var props = {
                            'Product ID': (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && String(window.ShopifyAnalytics.meta.product.id)) || '',
                            'URL': window.location.href
                        };
                        try {
                            if (window.Moengage && typeof Moengage.track_event === 'function') {
                                Moengage.track_event('pack_section_viewed', props);
                            }
                        } catch (e) {}
                        try {
                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    event: 'pack_section_viewed',
                                    product_id: props['Product ID'],
                                    ...getUTM(),
                                    ...getCustomer(),
                                    is_new_user: !localStorage.getItem("visited_before")
                                });
                            }
                        } catch (e) {}
                    });
                }, {
                    threshold: 0.3
                });
                io.observe(packEl);
            }
            initPackObserver();
            setTimeout(initPackObserver, 1500);
        })();

        // ── 9. product_image_swiped ───────────────────────────────────────
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.custom_image_wrapper .swiper-button-prev, .custom_image_wrapper .swiper-button-next, .main-prev, .main-next, .swiper-pagination-bullet, [class*="swiper-button"]');
            if (!btn) return;
            var direction = (btn.classList.contains('swiper-button-prev') || btn.classList.contains('main-prev')) ? 'prev' :
                (btn.classList.contains('swiper-button-next') || btn.classList.contains('main-next')) ? 'next' :
                'pagination';
            var wrapper = btn.closest('.custom_image_wrapper, .swiper, [class*="product-image"]');
            var activeSlide = wrapper ? wrapper.querySelector('.swiper-slide-active') : null;
            var imageIndex = activeSlide ? (parseInt(activeSlide.dataset.swiperSlideIndex || 0) + 1) : 0;
            var props = {
                'Direction': direction,
                'Image Index': imageIndex,
                'Product ID': (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && String(window.ShopifyAnalytics.meta.product.id)) || '',
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('product_image_swiped', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'product_image_swiped',
                        direction: direction,
                        image_index: imageIndex,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ─────────────────────────────────────────────
        //── 10. cart_upsell_viewed
        // Fires when upsell container becomes visible
        // inside dynamically loaded GoKwik cart drawer
        // ─────────────────────────────────────────────

        (function () {

        var cartUpsellViewedFired = false;

        function fireUpsellViewed(upsellEl) {

            if (cartUpsellViewedFired) return;

            cartUpsellViewedFired = true;

            var recommendedIds = [];
            var recommendedNames = [];

            // Collect upsell products
            upsellEl.querySelectorAll('.card').forEach(function(card) {

            var productName =
                card.querySelector('.product-name')?.innerText?.trim() || '';

            var productId =
                card.querySelector('.product-image')?.getAttribute('src') || '';

            recommendedNames.push(productName);
            recommendedIds.push(productId);

            });

            var payload = {
            event: 'cart_upsell_viewed',

            upsell_location: 'cart_drawer',

            recommended_product_id: recommendedIds,
            recommended_product_name: recommendedNames,

            page_url: window.location.href,

            ...getUTM(),
            ...getCustomer(),

            is_new_user: !localStorage.getItem("visited_before")
            };

            // GTM / GA4
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(payload);

            // MoEngage
            try {
            if (
                window.Moengage &&
                typeof Moengage.track_event === 'function'
            ) {
                Moengage.track_event('cart_upsell_viewed', payload);
            }
            } catch (e) {}

            console.log('cart_upsell_viewed fired', payload);
        }

        function initUpsellTracking() {

            // Dynamic shadow DOM host
            var host = document.querySelector('shadow-dom-container');

            if (!host || !host.shadowRoot) return;

            var shadow = host.shadowRoot;

            // Main scrollable cart wrapper
            var scrollWrapper = shadow.querySelector(
            '.side-cart-content-wrapper.show-scrollbar'
            );

            if (!scrollWrapper) return;

            // Upsell container
            var upsellEl = shadow.querySelector('.upSell-container');

            if (!upsellEl || upsellEl.__upsellObserverAttached) return;

            upsellEl.__upsellObserverAttached = true;

            // Intersection inside cart drawer scroll
            var observer = new IntersectionObserver(
            function(entries) {

                entries.forEach(function(entry) {

                if (
                    entry.isIntersecting &&
                    entry.intersectionRatio >= 0.3
                ) {

                    fireUpsellViewed(upsellEl);

                    observer.disconnect();
                }

                });

            },
            {
                root: scrollWrapper,
                threshold: [0.3]
            }
            );

            observer.observe(upsellEl);
        }

        // Watch for dynamically appended GoKwik cart
        var observer = new MutationObserver(function() {

            if (!cartUpsellViewedFired) {
            initUpsellTracking();
            }

        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Initial check
        initUpsellTracking();

        })();

        // ── 11. coupon_failed (MutationObserver on cart error area) ───────
        (function() {
            var _lastCouponErr = '';

            function observeCouponErrors(root) {
                if (!root) return;
                var mo = new MutationObserver(function() {
                    var errEls = root.querySelectorAll('[class*="error"], [class*="alert"], [class*="message--error"], [class*="discount-error"], [id*="discount-error"]');
                    errEls.forEach(function(el) {
                        var txt = (el.textContent || '').trim();
                        if (!txt) return;
                        if (txt === _lastCouponErr) return;
                        var lower = txt.toLowerCase();
                        if (lower.indexOf('discount') !== -1 || lower.indexOf('coupon') !== -1 || lower.indexOf('promo') !== -1 || lower.indexOf('code') !== -1 || lower.indexOf('invalid') !== -1 || lower.indexOf('expired') !== -1) {
                            _lastCouponErr = txt;
                            var couponInput = root.querySelector('input[name="discount"], input[id*="discount"], input[placeholder*="coupon"], input[placeholder*="promo"]');
                            var couponCode = couponInput ? (couponInput.value || '').trim() : '';
                            var props = {
                                'Error Message': txt.substring(0, 200),
                                'Coupon Code': couponCode,
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            };
                            try {
                                if (window.Moengage && typeof Moengage.track_event === 'function') {
                                    Moengage.track_event('coupon_failed', props);
                                }
                            } catch (e) {}
                            try {
                                if (window.dataLayer) {
                                    window.dataLayer.push({
                                        event: 'coupon_failed',
                                        error_message: txt.substring(0, 200),
                                        coupon_code: couponCode,
                                        ...getUTM(),
                                        ...getCustomer(),
                                        is_new_user: !localStorage.getItem("visited_before")
                                    });
                                }
                            } catch (e) {}
                        }
                    });
                });
                mo.observe(root, {
                    childList: true,
                    subtree: true,
                    characterData: true
                });
            }
            // Watch cart drawer (standard Shopify)
            var cartDrawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, [id*="CartDrawer"]');
            if (cartDrawer) observeCouponErrors(cartDrawer);
            // Also watch for cart drawer appearing dynamically
            var _couponMO = new MutationObserver(function() {
                var cd = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer, [id*="CartDrawer"]');
                if (cd && !cd._couponObserved) {
                    cd._couponObserved = true;
                    observeCouponErrors(cd);
                }
            });
            _couponMO.observe(document.body, {
                childList: true,
                subtree: false
            });
        })();

        // ── 12. sign_up_attempted ─────────────────────────────────────────
        document.addEventListener('submit', function(e) {
            var form = e.target.closest('form#create_customer, form#create-customer, form[id*="register"], form[action*="account"][action*="register"], form[action="/account"]');
            if (!form) return;
            // Check if the form has register-specific fields (distinguishes from login form)
            if (!form.querySelector('[name="customer[password]"], [name="customer[first_name]"], [name="customer[email]"]')) return;
            var emailInput = form.querySelector('input[type="email"], input[name="customer[email]"], #RegisterForm-email');
            var email = emailInput ? (emailInput.value || '').trim() : '';
            var props = {
                'Email': email,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
                
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('sign_up_attempted', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'sign_up_attempted',
                        email_provided: !!email,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            // After submit, also detect form errors (async check)
            setTimeout(function() {
                var errEl = form.querySelector('.form-error, .form-message--error, [class*="form-error"], [class*="alert--error"]');
                if (errEl && errEl.textContent.trim()) {
                    var errProps = {
                        'Email': email,
                        'Error Message': (errEl.textContent || '').trim().substring(0, 200),
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    };
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('sign_up_failed', errProps);
                        }
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'sign_up_failed',
                                'Email': email,
                                'Error Message': (errEl.textContent || '').trim().substring(0, 200),
                                'URL': window.location.href,
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }
            }, 1000);
        }, true);

        // ── 13. login_failed ──────────────────────────────────────────────
        document.addEventListener('submit', function(e) {
            var form = e.target.closest('form[action*="account/login"], form[action="/account/login"], form#customer_login, form[id*="login"]');
            if (!form) return;
            var emailInput = form.querySelector('input[type="email"], input[name="customer[email]"], #CustomerEmail');
            var email = emailInput ? (emailInput.value || '').trim() : '';
            // Detect error after navigation (on page with error already visible)
            var errEl = document.querySelector('.form-error.alert.alert--error, .form-message.form-message--error, [class*="form-error"]');
            var props = {
                'Email': email,
                'Error Visible': !!errEl,
                'Error Message': errEl ? (errEl.textContent || '').trim().substring(0, 200) : '',
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('login_attempted', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'login_attempted',
                        email_provided: !!email,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
            // Also check after submit for error
            setTimeout(function() {
                var postErrEl = form.querySelector('.form-error, .form-message--error, [class*="alert--error"]');
                if (postErrEl && postErrEl.textContent.trim()) {
                    var failProps = {
                        'Email': email,
                        'Error Message': (postErrEl.textContent || '').trim().substring(0, 200),
                        'URL': window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    };
                    try {
                        if (window.Moengage && typeof Moengage.track_event === 'function') {
                            Moengage.track_event('login_failed', failProps);
                        }
                    } catch (e) {}
                    try {
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'login_failed',
                                error_message: failProps['Error Message'],
                                ...getUTM(),
                                ...getCustomer(),
                                is_new_user: !localStorage.getItem("visited_before")
                            });
                        }
                    } catch (e) {}
                }
            }, 1200);
        }, true);

        // Also fire login_failed immediately on page load if error is already shown
        (function() {
            var path = window.location.pathname;
            if (path.indexOf('/account/login') === -1 && path.indexOf('account/login') === -1) return;
            var errEl = document.querySelector('.form-error.alert.alert--error, .form-message.form-message--error, [class*="form-error"]');
            if (!errEl || !errEl.textContent.trim()) return;
            var props = {
                'Error Message': (errEl.textContent || '').trim().substring(0, 200),
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('login_failed', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'login_failed',
                        error_message: props['Error Message'],
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        })();

        // ── 14. address_added ─────────────────────────────────────────────
        document.addEventListener('submit', function(e) {
            // Shopify themes use various IDs for the new-address form: AddAddress, address_form_new, etc.
            // We distinguish new (action="/account/addresses" exactly) from edit (action ends in /{id})
            var form = e.target.closest('#AddAddress, #address_form_new, form[id*="AddAddress"], form[id*="address_form_new"], form[data-address-new]');
            if (!form) {
                // Fallback: match any form with action /account/addresses (no trailing slash + ID)
                var candidate = e.target.closest('form[action="/account/addresses"], form[action*="account/addresses"]');
                if (candidate) {
                    var act = candidate.getAttribute('action') || '';
                    // Only fire address_added if this is the NEW address form (action = /account/addresses, not /account/addresses/123)
                    var isEditForm = /\/account\/addresses\/\d/.test(act);
                    if (!isEditForm && candidate.querySelector('[name*="address1"]')) form = candidate;
                }
            }
            if (!form) return;
            var addr1 = (form.querySelector('[name*="address1"], [id*="address1"]') || {}).value || '';
            var city = (form.querySelector('[name*="city"], [id*="city"]') || {}).value || '';
            var zip = (form.querySelector('[name*="zip"], [name*="postal"], [id*="zip"]') || {}).value || '';
            var props = {
                'Address Line 1': addr1.trim(),
                'City': city.trim(),
                'ZIP': zip.trim(),
                'URL': window.location.href
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('address_added', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'address_added',
                        city: city.trim(),
                        zip: zip.trim(),
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 15. address_updated ───────────────────────────────────────────
        document.addEventListener('submit', function(e) {
            var form = e.target.closest('form[action*="account/addresses/"], form[id*="EditAddress"], form[data-address-id]');
            if (!form) return;
            var addrId = form.action ? form.action.split('/').pop() : (form.dataset.addressId || '');
            var city = (form.querySelector('[name*="city"], [id*="city"]') || {}).value || '';
            var zip = (form.querySelector('[name*="zip"], [name*="postal"], [id*="zip"]') || {}).value || '';
            var props = {
                'Address ID': addrId,
                'City': city.trim(),
                'ZIP': zip.trim(),
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('address_updated', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'address_updated',
                        address_id: addrId,
                        ...getUTM(),
                    ...getCustomer(),
                    is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 16. app_download_cta_clicked ──────────────────────────────────
        document.addEventListener('click', function(e) {
            var btn = e.target.closest('.download_btn, a[href*="play.google.com"], a[href*="apps.apple.com"], a[href*="appstore"], a[href*="playstore"], [class*="app-download"], [class*="download-app"], [id*="appbrew-button"]');
            if (!btn) return;
            var href = btn.href || (btn.closest('a') ? btn.closest('a').href : '');
            var platform = href.indexOf('play.google.com') !== -1 ? 'android' :
                href.indexOf('apps.apple.com') !== -1 ? 'ios' :
                (btn.classList.contains('android') ? 'android' : 'general');
            var props = {
                'Platform': platform,
                'Button Text': (btn.textContent || '').trim().substring(0, 80),
                'Destination URL': href,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('app_download_cta_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'app_download_cta_clicked',
                        platform: platform,
                        destination_url: href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 17 & 18. pdp_to_cart_conversion + cart_to_checkout_conversion ─
        // Implemented via the dataLayer.push override at the top of this block.

        // ── 19. shop_more_clicked ─────────────────────────────────────────
        (function() {
            var path = window.location.pathname;
            if (path.indexOf('/thank') === -1 && path.indexOf('/orders') === -1 && path.indexOf('/checkouts') === -1) return;
            document.addEventListener('click', function(e) {
                var link = e.target.closest('a[href*="/collections"], a[href*="/products"], .reversed-link, [class*="continue-shopping"], [class*="shop-more"]');
                if (!link) return;
                var props = {
                    'Link Text': (link.textContent || '').trim().substring(0, 80),
                    'Destination URL': link.href || '',
                    'URL': window.location.href,
                    ...getUTM(),
                    ...getCustomer(),
                    is_new_user: !localStorage.getItem("visited_before")
                };
                try {
                    if (window.Moengage && typeof Moengage.track_event === 'function') {
                        Moengage.track_event('shop_more_clicked', props);
                    }
                } catch (e) {}
                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'shop_more_clicked',
                            destination_url: props['Destination URL'],
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
            }, true);
        })();

        // ── 20. blog_to_pdp_clicked ───────────────────────────────────────
        document.addEventListener('click', function(e) {
            var link = e.target.closest('a[href*="/products/"]');
            if (!link) return;
            var article = link.closest('.article, .blog-article, .article__content, [class*="article__body"], main article, .rte');
            if (!article) return;
            var productHandle = (link.href.match(/\/products\/([^?#/]+)/) || [])[1] || '';
            var props = {
                'Product Handle': productHandle,
                'Product URL': link.href,
                'Blog URL': window.location.href,
                'Link Text': (link.textContent || '').trim().substring(0, 80),
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('blog_to_pdp_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'blog_to_pdp_clicked',
                        product_handle: productHandle,
                        blog_url: window.location.href,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 21. concern_filter_applied ────────────────────────────────────
        document.addEventListener('change', function(e) {
            var input = e.target.closest('facet-form input[type="checkbox"], facet-form input[type="radio"], facet-form select, [is="facet-form"] input, [is="facet-form"] select, .facet-filters input, .collection-filters input');
            if (!input) return;
            var filterName = (input.name || input.dataset.filterName || input.id || '').replace(/filter\./gi, '').replace(/\./g, ' ').replace(/_/g, ' ').trim();
            var filterValue = (input.value || input.dataset.value || (input.options && input.options[input.selectedIndex] && input.options[input.selectedIndex].text) || '').trim();
            var collName = (document.querySelector('.collection__title, .collection-hero__title, h1') || {}).textContent || '';
            collName = collName.trim().substring(0, 80);
            var props = {
                'Filter Name': filterName,
                'Filter Value': filterValue,
                'Is Checked': input.type === 'checkbox' ? input.checked : undefined,
                'Collection Name': collName,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('concern_filter_applied', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'concern_filter_applied',
                        filter_name: filterName,
                        filter_value: filterValue,
                        collection_name: collName,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 22. rewards_cta_clicked ───────────────────────────────────────
        document.addEventListener('click', function(e) {
            var el = e.target.closest('a[href*="nector"], [class*="nector"] a, [id*="nector"] a, a[href="#show-nector-rewards"], [data-nector], .nector-coins-block a, #nector-customer-available-coins');
            if (!el) return;
            var btnText = (el.textContent || '').trim().substring(0, 80);
            var dest = el.tagName === 'A' ? (el.href || '') : '';
            var props = {
                'Button Text': btnText,
                'Destination URL': dest,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('rewards_cta_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'rewards_cta_clicked',
                        button_text: btnText,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);

        // ── 23. referral_link_clicked (URL parameter detection) ───────────
        (function() {
            try {
                var params = new URLSearchParams(window.location.search);
                var refCode = params.get('ref') || params.get('referral_code') || params.get('referrer_id') || params.get('referral') || '';
                if (!refCode) return;
                var props = {
                    'Referral Code': refCode,
                    'Landing Page': window.location.href
                };
                try {
                    if (window.Moengage && typeof Moengage.track_event === 'function') {
                        Moengage.track_event('referral_link_clicked', props);
                    }
                } catch (e) {}
                try {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'referral_link_clicked',
                            referral_code: refCode,
                            landing_page: window.location.href,
                            ...getUTM(),
                            ...getCustomer(),
                            is_new_user: !localStorage.getItem("visited_before")
                        });
                    }
                } catch (e) {}
            } catch (e) {}
        })();

        // ── 24. concern_nav_clicked (header nav concern links) ────────────
        // Supplements the existing shop_by_concern event in collection-list.liquid
        // by also capturing clicks on header nav concern links.
        document.addEventListener('click', function(e) {
            var link = e.target.closest('.menu-child-nav a, .sub-menu-child a, .menu-heading, [class*="concern"] a, header a[href*="/collections/"]');
            if (!link) return;
            var navParent = link.closest('.sub-menu, .menu-child-nav, [class*="concern-nav"], [class*="sub-menu"]');
            if (!navParent) return;
            var concernName = (link.textContent || '').trim().substring(0, 80);
            var dest = link.href || '';
            var collHandle = (dest.match(/\/collections\/([^?#/]+)/) || [])[1] || '';
            var props = {
                'Concern Name': concernName,
                'Collection Handle': collHandle,
                'Destination URL': dest,
                'URL': window.location.href,
                ...getUTM(),
                ...getCustomer(),
                is_new_user: !localStorage.getItem("visited_before")
            };
            try {
                if (window.Moengage && typeof Moengage.track_event === 'function') {
                    Moengage.track_event('concern_nav_clicked', props);
                }
            } catch (e) {}
            try {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'concern_nav_clicked',
                        concern_name: concernName,
                        collection_handle: collHandle,
                        ...getUTM(),
                        ...getCustomer(),
                        is_new_user: !localStorage.getItem("visited_before")
                    });
                }
            } catch (e) {}
        }, true);
    });


